// // import React, { useEffect, useState, useCallback } from 'react';
// // import { Box, Typography, Button, Dialog, DialogActions, DialogContent, TextField, IconButton, MenuItem, Select, InputLabel, FormControl, FormHelperText, Chip, Tooltip, Divider, Stack, Autocomplete, CircularProgress, } from '@mui/material';
// // import { Delete, Edit, QrCode2, Add, FilterList, Inventory2, Close, CloudUpload, Image as ImageIcon, Person, Download as DownloadIcon } from '@mui/icons-material';
// // import axios from 'axios';
// // import TableComponent from '../../Components/TableComponent/TableComponent';
// // import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// // import { LoadingSpinner } from '../../Components/spinner/spinner';
// // import api from '../../api/axiosInterceptor';
// // import { API_BASE_URL } from '../../config';
// // import * as XLSX from 'xlsx';
// // import { saveAs } from 'file-saver';

// // // ─── Constants ────────────────────────────────────────────────────────────────
// // const CATEGORY_CODES = [
// //   { value: 'AC',  label: 'Air Conditioners' },
// //   { value: 'PCP', label: 'Computers & Peripherals' },
// //   { value: 'EEG', label: 'Electrical & Electronic Goods' },
// //   { value: 'FF',  label: 'Furniture & Fixtures' },
// //   { value: 'MTP', label: 'Machinery, Tools & Plant' },
// //   { value: 'TXT', label: 'Textiles' },
// //   { value: 'VEH', label: 'Vehicles' },
// //   { value: 'ANC', label: 'Art Objects & Handicrafts' },
// // ];

// // const RATINGS    = ['EXCLUSIVE', 'HIGH', 'AVERAGE', 'LOW'];
// // const CONDITIONS = ['NEW','UNUSED','WORKING','DAMAGED','OBSOLETE','SCRAP','APPRECIATING','DEPRECIATING'];

// // const CATEGORY_COLORS = {
// //   AC:'#0ea5e9', PCP:'#8b5cf6', EEG:'#f59e0b', FF:'#10b981', MTP:'#ef4444', 
// //   TXT:'#ec4899', VEH:'#f97316', ANC:'#6366f1',
// // };

// // const CONDITION_COLORS = {
// //   NEW:'#10b981', UNUSED:'#06b6d4', WORKING:'#3b82f6', DAMAGED:'#f59e0b', 
// //   OBSOLETE:'#6b7280', SCRAP:'#ef4444', APPRECIATING:'#8b5cf6', DEPRECIATING:'#f97316',
// // };

// // const EMPTY_FORM = {
// //   category_code:'', sub_code:'', object_code:'', detail_code:'', serial_no_of_group:'',
// //   name_of_item:'', serial_no_of_item:'', description:'', make_brand:'', rating:'', condition:'',
// //   condition_details:'', fe: null,
// // };

// // // ─── Hook: fetch Financial Establishment list ─────────────────────────────────
// // const useFetchFeBaseList = () => {
// //   const [list, setList]       = useState([]);
// //   const [loading, setLoading] = useState(false);

// //   useEffect(() => {
// //     setLoading(true);
// //     axios.get(`${API_BASE_URL}/fe-mgmt/fe-base/`)
// //       .then(res => setList(res.data || []))
// //       .catch(() => setList([]))
// //       .finally(() => setLoading(false));
// //   }, []);

// //   return { list, loading };
// // };

// // // ─── Sub-components ───────────────────────────────────────────────────────────
// // const CategoryBadge = ({ code }) => (
// //   <Box sx={{ 
// //     display:'inline-flex', alignItems:'center', gap:0.5, px:1.2, py:0.3, 
// //     borderRadius:1.5, backgroundColor:`${CATEGORY_COLORS[code]||'#6b7280'}18`, 
// //     border:`1px solid ${CATEGORY_COLORS[code]||'#6b7280'}40`,
// //   }}>
// //     <Box sx={{ width:6, height:6, borderRadius:'50%', backgroundColor:CATEGORY_COLORS[code]||'#6b7280' }} />
// //     <Typography sx={{ fontSize:12, fontWeight:700, color:CATEGORY_COLORS[code]||'#6b7280' }}>
// //       {code}
// //     </Typography>
// //   </Box>
// // );

// // const ConditionBadge = ({ condition }) => (
// //   <Chip label={condition||'—'} size="small" sx={{ 
// //     fontSize:11, fontWeight:600, height:22, 
// //     backgroundColor:`${CONDITION_COLORS[condition]||'#6b7280'}18`, 
// //     color:CONDITION_COLORS[condition]||'#6b7280', 
// //     border:`1px solid ${CONDITION_COLORS[condition]||'#6b7280'}40`,
// //   }} />
// // );

// // const FeBadge = ({ feObj, feId, feName }) => {
// //   const name = feObj?.name_of_fe || feName || feId || '—';
// //   return name !== '—' ? (
// //     <Box sx={{ 
// //       display:'inline-flex', alignItems:'center', gap:0.5, px:1.2, py:0.3, 
// //       borderRadius:1.5, backgroundColor:'rgba(99,102,241,0.1)', 
// //       border:'1px solid rgba(99,102,241,0.3)',
// //     }}>
// //       <Person sx={{ fontSize:12, color:'#6366f1' }} />
// //       <Typography sx={{ fontSize:12, fontWeight:600, color:'#6366f1' }}>
// //         {typeof name === 'object' ? name.name_of_fe || name : name}
// //       </Typography>
// //     </Box>
// //   ) : (
// //     <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>
// //   );
// // };

// // const UploadBox = ({ file, onChange, existingUrl, label }) => (
// //   <Box>
// //     <Typography sx={{ fontSize:11, color:'#64748b', mb:0.5, fontWeight:600 }}>
// //       {label}
// //     </Typography>
// //     <Box 
// //       component="label" 
// //       sx={{ 
// //         border:`2px dashed ${file ? '#0ea5e9' : '#cbd5e1'}`, borderRadius:2, p:2, 
// //         textAlign:'center', cursor:'pointer', backgroundColor: file ? 'rgba(14,165,233,0.04)' : '#f8fafc', 
// //         display:'block', transition:'all 0.2s', 
// //         '&:hover':{ borderColor:'#0ea5e9', backgroundColor:'rgba(14,165,233,0.04)' },
// //       }}
// //     >
// //       <input type="file" accept="image/*" hidden onChange={e => onChange(e.target.files[0])} />
// //       <CloudUpload sx={{ fontSize:26, color:file?'#0ea5e9':'#cbd5e1', mb:0.5 }} />
// //       <Typography sx={{ fontSize:12, color:file?'#0ea5e9':'#94a3b8', fontWeight:600, wordBreak:'break-all' }}>
// //         {file ? file.name : 'Click to upload'}
// //       </Typography>
// //     </Box>
// //     {!file && existingUrl && (
// //       <Typography sx={{ fontSize:11, color:'#10b981', mt:0.5 }}>
// //         ✓ <a href={existingUrl} target="_blank" rel="noreferrer" style={{ color:'#10b981' }}>Current photo</a>
// //       </Typography>
// //     )}
// //   </Box>
// // );

// // const SectionLabel = ({ children }) => (
// //   <Typography sx={{ 
// //     fontSize:11, fontWeight:700, letterSpacing:1.2, color:'#94a3b8', 
// //     textTransform:'uppercase', mb:1.5,
// //   }}>
// //     {children}
// //   </Typography>
// // );

// // // ─── Main Component ───────────────────────────────────────────────────────────
// // export const MovableItemsComponent = () => {
// //   const { list: feList, loading: feLoading } = useFetchFeBaseList();
  
// //   const [rows, setRows]                      = useState([]);
// //   const [loading, setLoading]                = useState(true);
// //   const [submitLoading, setSubmitLoading]    = useState(false);
// //   const [activeFilter, setActiveFilter]      = useState('ALL');
// //   const [snackbarOpen, setSnackbarOpen]      = useState(false);
// //   const [snackbarMessage, setSnackbarMessage] = useState('');
// //   const [snackbarSeverity, setSnackbarSeverity] = useState('info');
// //   const [openFormDialog, setOpenFormDialog]  = useState(false);
// //   const [isEditMode, setIsEditMode]          = useState(false);
// //   const [selectedItem, setSelectedItem]      = useState(null);
// //   const [formData, setFormData]              = useState(EMPTY_FORM);
// //   const [formErrors, setFormErrors]          = useState({});
// //   const [groupPhoto, setGroupPhoto]          = useState(null);
// //   const [samplePhoto, setSamplePhoto]        = useState(null);
// //   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
// //   const [deleteItem, setDeleteItem]          = useState(null);
// //   const [selectedFe, setSelectedFe]          = useState(null);

// //   // ── Data ─────────────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     fetchItems();
// //   }, []);

// //   const fetchItems = (categoryCode = null) => {
// //     setLoading(true);
// //     const url = categoryCode && categoryCode !== 'ALL' 
// //       ? `/evalueM/movable-items/?category_code=${categoryCode}` 
// //       : `/evalueM/movable-items/`;
    
// //     api.get(url)
// //       .then(res => setRows(res.data.map((item, i) => ({ ...item, slNo: i + 1 }))))
// //       .catch(() => showSnackbar('Failed to load movable items.', 'error'))
// //       .finally(() => setLoading(false));
// //   };

// //   const showSnackbar = (msg, sev = 'info') => {
// //     setSnackbarMessage(msg);
// //     setSnackbarSeverity(sev);
// //     setSnackbarOpen(true);
// //   };

// //   const handleFilter = (code) => {
// //     setActiveFilter(code);
// //     fetchItems(code);
// //   };

// //   // ── Excel Export ─────────────────────────────────────────────────────────
// //   const exportToExcel = useCallback(() => {
// //     const headers = [
// //       'Sl No.', 'Category', 'Full Code', 'Item Name', 'Serial No.',
// //       'Make/Brand', 'Financial Establishment', 'Condition', 'Rating',
// //       'QR Sticker Link', 'Group Photo Link', 'Sample Photo Link',
// //     ];

// //     const excelData = rows.map((row) => ({
// //       'Sl No.':                   row.slNo,
// //       'Category':                 row.category_code || '',
// //       'Full Code':                row.full_code || '',
// //       'Item Name':                row.name_of_item || '',
// //       'Serial No.':               row.serial_no_of_item || '',
// //       'Make/Brand':               row.make_brand || '',
// //       'Financial Establishment':  row.fe_name || row.fe?.name_of_fe || '',
// //       'Condition':                row.condition || '',
// //       'Rating':                   row.rating || '',
// //       'QR Sticker Link':          row.qr_sticker_url || '',
// //       'Group Photo Link':         row.group_photo_url || '',
// //       'Sample Photo Link':        row.sample_photo_url || '',
// //     }));

// //     const wb = XLSX.utils.book_new();
// //     const ws = XLSX.utils.json_to_sheet(excelData, { header: headers });

// //     // Column widths
// //     ws['!cols'] = [
// //       { wch: 8 },  // Sl No.
// //       { wch: 12 }, // Category
// //       { wch: 22 }, // Full Code
// //       { wch: 25 }, // Item Name
// //       { wch: 15 }, // Serial No.
// //       { wch: 18 }, // Make/Brand
// //       { wch: 32 }, // Financial Establishment
// //       { wch: 14 }, // Condition
// //       { wch: 12 }, // Rating
// //       { wch: 55 }, // QR Sticker Link
// //       { wch: 55 }, // Group Photo Link
// //       { wch: 55 }, // Sample Photo Link
// //     ];

// //     // Add clickable hyperlinks for QR, Group Photo, Sample Photo columns
// //     // Columns: J = QR (index 9), K = Group Photo (index 10), L = Sample Photo (index 11)
// //     const linkCols = [
// //       { colIndex: 9,  field: 'qr_sticker_url' },
// //       { colIndex: 10, field: 'group_photo_url' },
// //       { colIndex: 11, field: 'sample_photo_url' },
// //     ];

// //     rows.forEach((row, rowIndex) => {
// //       const excelRow = rowIndex + 2; // +2 because row 1 is header
// //       linkCols.forEach(({ colIndex, field }) => {
// //         const url = row[field];
// //         if (url) {
// //           const cellRef = XLSX.utils.encode_cell({ r: excelRow - 1, c: colIndex });
// //           if (ws[cellRef]) {
// //             ws[cellRef].l = { Target: url, Tooltip: url };
// //             // Style as hyperlink (blue underline)
// //             ws[cellRef].s = {
// //               font: { color: { rgb: '0563C1' }, underline: true },
// //             };
// //           }
// //         }
// //       });
// //     });

// //     XLSX.utils.book_append_sheet(wb, ws, 'Movable Items');
// //     const dateStr = new Date().toISOString().slice(0, 10);
// //     XLSX.writeFile(wb, `Movable_Items_${dateStr}.xlsx`);

// //     showSnackbar('Excel file downloaded successfully!', 'success');
// //   }, [rows]);

// //   // ── Columns ──────────────────────────────────────────────────────────────
// //   const columns = [
// //     { id:'slNo', field:'slNo', headerName:'Sl No.', width:70 },
// //     { 
// //       id:'category_code', field:'category_code', headerName:'Category', width:110, 
// //       renderCell:(p) => <CategoryBadge code={p.value} />,
// //     },
// //     { 
// //       id:'full_code', field:'full_code', headerName:'Full Code', width:170,
// //       renderCell:(p) => (
// //         <Typography sx={{ fontFamily:'monospace', fontSize:12, color:'#475569', fontWeight:600 }}>
// //           {p.value}
// //         </Typography>
// //       ),
// //     },
// //     { id:'name_of_item', field:'name_of_item', headerName:'Item Name', width:190 },
// //     { id:'serial_no_of_item', field:'serial_no_of_item', headerName:'Serial No.', width:120 },
// //     { id:'make_brand', field:'make_brand', headerName:'Make/Brand', width:130 },
// //     { 
// //       id:'fe_name', field:'fe_name', headerName:'Financial Establishment', width:220,
// //       renderCell:(p) => {
// //         const row = p.row;
// //         return (
// //           <FeBadge feObj={row.fe} feId={row.fe} feName={row.fe_name || row.fe?.name_of_fe} />
// //         );
// //       },
// //     },
// //     { 
// //       id:'condition', field:'condition', headerName:'Condition', width:130, 
// //       renderCell:(p) => <ConditionBadge condition={p.value} />,
// //     },
// //     { 
// //       id:'rating', field:'rating', headerName:'Rating', width:95,
// //       renderCell:(p) => (
// //         <Typography sx={{ fontSize:12, fontWeight:600, color:'#64748b' }}>
// //           {p.value||'—'}
// //         </Typography>
// //       ),
// //     },
// //     { 
// //       id:'qr_sticker_url', field:'qr_sticker_url', headerName:'QR', width:65,
// //       renderCell:(p) => p.value ? (
// //         <Tooltip title="View QR Sticker" arrow>
// //           <IconButton size="small" onClick={() => window.open(p.value,'_blank')} 
// //             sx={{ color:'#0ea5e9','&:hover':{ backgroundColor:'rgba(14,165,233,0.1)' } }}>
// //             <QrCode2 fontSize="small" />
// //           </IconButton>
// //         </Tooltip>
// //       ) : (
// //         <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>
// //       ),
// //     },
// //     { 
// //       id:'photos', field:'photos', headerName:'Photos', width:75,
// //       renderCell:(p) => {
// //         const row = p.row;
// //         const hasGroupPhoto = row.group_photo_url;
// //         const hasSamplePhoto = row.sample_photo_url;
        
// //         if (!hasGroupPhoto && !hasSamplePhoto) {
// //           return <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>;
// //         }
        
// //         return (
// //           <Box sx={{ display: 'flex', gap: 0.25, flexDirection: 'column' }}>
// //             {hasGroupPhoto && (
// //               <Tooltip title="Group Photo" arrow>
// //                 <IconButton size="small" onClick={() => window.open(row.group_photo_url, '_blank')} 
// //                   sx={{ color:'#10b981', '&:hover':{ backgroundColor:'rgba(16,185,129,0.1)' }, p: 0.25 }}>
// //                   <ImageIcon fontSize="small" />
// //                 </IconButton>
// //               </Tooltip>
// //             )}
// //             {hasSamplePhoto && (
// //               <Tooltip title="Sample Photo" arrow>
// //                 <IconButton size="small" onClick={() => window.open(row.sample_photo_url, '_blank')} 
// //                   sx={{ color:'#3b82f6', '&:hover':{ backgroundColor:'rgba(59,130,246,0.1)' }, p: 0.25 }}>
// //                   <ImageIcon fontSize="small" />
// //                 </IconButton>
// //               </Tooltip>
// //             )}
// //           </Box>
// //         );
// //       },
// //     },
// //     { 
// //       id:'actions', field:'actions', headerName:'Actions', width:100,
// //       renderCell:(p) => (
// //         <Box sx={{ display:'flex', gap:0.5 }}>
// //           <Tooltip title="Edit" arrow>
// //             <IconButton size="small" onClick={() => handleEdit(p.row)} 
// //               sx={{ color:'#3b82f6','&:hover':{ backgroundColor:'rgba(59,130,246,0.1)' } }}>
// //               <Edit fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //           <Tooltip title="Delete" arrow>
// //             <IconButton size="small" onClick={() => handleDeleteConfirmation(p.row)} 
// //               sx={{ color:'#ef4444','&:hover':{ backgroundColor:'rgba(239,68,68,0.1)' } }}>
// //               <Delete fontSize="small" />
// //             </IconButton>
// //           </Tooltip>
// //         </Box>
// //       ),
// //     },
// //   ];

// //   // ── CRUD ─────────────────────────────────────────────────────────────────
// //   const handleAdd = () => {
// //     setIsEditMode(false);
// //     setFormData(EMPTY_FORM);
// //     setSelectedFe(null);
// //     setGroupPhoto(null);
// //     setSamplePhoto(null);
// //     setFormErrors({});
// //     setOpenFormDialog(true);
// //   };

// //   const handleEdit = (item) => {
// //     setIsEditMode(true);
// //     setSelectedItem(item);
// //     setFormData({
// //       category_code:      item.category_code      || '',
// //       sub_code:           item.sub_code           || '',
// //       object_code:        item.object_code        || '',
// //       detail_code:        item.detail_code        || '',
// //       serial_no_of_group: item.serial_no_of_group || '',
// //       name_of_item:       item.name_of_item       || '',
// //       serial_no_of_item:  item.serial_no_of_item  || '',
// //       description:        item.description        || '',
// //       make_brand:         item.make_brand         || '',
// //       rating:             item.rating             || '',
// //       condition:          item.condition          || '',
// //       condition_details:  item.condition_details  || '',
// //       fe:                 item.fe                 || null,
// //     });

// //     const matchedFe = feList.find(f => f.id === item.fe) || null;
// //     setSelectedFe(
// //       matchedFe ? matchedFe : item.fe_name ? { id: item.fe, name_of_fe: item.fe_name } : null
// //     );
    
// //     setGroupPhoto(null);
// //     setSamplePhoto(null);
// //     setFormErrors({});
// //     setOpenFormDialog(true);
// //   };

// //   const handleDeleteConfirmation = (item) => {
// //     setDeleteItem(item);
// //     setDeleteDialogOpen(true);
// //   };

// //   const handleDelete = () => {
// //     api.delete(`/evalueM/movable-items/${deleteItem.id}/`)
// //       .then(() => {
// //         showSnackbar('Item deleted successfully.', 'success');
// //         fetchItems(activeFilter);
// //       })
// //       .catch(() => showSnackbar('Failed to delete item.', 'error'))
// //       .finally(() => {
// //         setDeleteDialogOpen(false);
// //         setDeleteItem(null);
// //       });
// //   };

// //   const validate = () => {
// //     const e = {};
// //     if (!formData.category_code)         e.category_code = 'Category is required';
// //     if (!formData.name_of_item?.trim())  e.name_of_item  = 'Item name is required';
// //     setFormErrors(e);
// //     return Object.keys(e).length === 0;
// //   };

// //   const handleSubmit = () => {
// //     if (!validate()) return;
    
// //     setSubmitLoading(true);
// //     const form = new FormData();
    
// //     Object.entries(formData).forEach(([k, v]) => {
// //       if (v !== null && v !== undefined) form.append(k, v);
// //     });
    
// //     if (groupPhoto)  form.append('group_photo_url',  groupPhoto);
// //     if (samplePhoto) form.append('sample_photo_url', samplePhoto);
    
// //     const req = isEditMode 
// //       ? api.patch(`/evalueM/movable-items/${selectedItem.id}/`, form, { 
// //           headers:{ 'Content-Type':'multipart/form-data' } 
// //         })
// //       : api.post(`/evalueM/movable-items/`, form, { 
// //           headers:{ 'Content-Type':'multipart/form-data' } 
// //         });

// //     req
// //       .then(() => {
// //         showSnackbar(`Item ${isEditMode ? 'updated' : 'added'} & QR sticker generated!`, 'success');
// //         fetchItems(activeFilter);
// //       })
// //       .catch(() => showSnackbar(`Failed to ${isEditMode ? 'update' : 'add'} item.`, 'error'))
// //       .finally(() => {
// //         setSubmitLoading(false);
// //         setOpenFormDialog(false);
// //       });
// //   };

// //   const f = (key) => ({
// //     value:       formData[key],
// //     error:       !!formErrors[key],
// //     helperText:  formErrors[key],
// //     onChange:    (e) => setFormData(p => ({ ...p, [key]: e.target.value })),
// //   });

// //   if (loading) return <LoadingSpinner size={30} />;

// //   // ── Render ────────────────────────────────────────────────────────────────
// //   return (
// //     <Box sx={{ width:'100%', mt:8, mb:1, borderRadius:3, overflow:'visible', boxShadow:'0 8px 32px rgba(15,23,42,0.12)', backgroundColor:'#fff' }}>

// //       {/* ── Header ── */}
// //       <Box sx={{ 
// //         background:'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #0284c7 100%)', 
// //         px:3, py:2.5, display:'flex', justifyContent:'space-between', alignItems:'center',
// //         flexWrap:'wrap', gap:1.5,
// //       }}>
// //         {/* Title */}
// //         <Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
// //           <Box sx={{ 
// //             width:48, height:48, borderRadius:2, 
// //             background:'rgba(14,165,233,0.2)', border:'1px solid rgba(14,165,233,0.4)', 
// //             display:'flex', alignItems:'center', justifyContent:'center',
// //           }}>
// //             <Inventory2 sx={{ color:'#0ea5e9', fontSize:26 }} />
// //           </Box>
// //           <Box>
// //             <Typography sx={{ color:'#fff', fontWeight:800, fontSize:20, letterSpacing:-0.5 }}>
// //               Movable Assets
// //             </Typography>
// //             <Typography sx={{ color:'rgba(255,255,255,0.45)', fontSize:12 }}>
// //               eValueM · QR Coding & Valuation Module
// //             </Typography>
// //           </Box>
// //         </Box>

// //         {/* ── Action Buttons ── */}
// //         <Box sx={{ display:'flex', gap:1.5, alignItems:'center', flexShrink:0 }}>
// //           <Button
// //             startIcon={<Add />}
// //             onClick={handleAdd}
// //             sx={{ 
// //               background:'linear-gradient(135deg,#0ea5e9,#2563eb)',
// //               color:'#fff',
// //               fontWeight:700,
// //               borderRadius:2,
// //               px:2.5,
// //               py:1,
// //               textTransform:'none',
// //               whiteSpace:'nowrap',
// //               boxShadow:'0 4px 14px rgba(14,165,233,0.4)',
// //               '&:hover':{ background:'linear-gradient(135deg,#0284c7,#1d4ed8)', transform:'translateY(-1px)' },
// //               transition:'all 0.2s',
// //             }}
// //           >
// //             Add Item
// //           </Button>
// //         </Box>
// //       </Box>

// //       {/* ── Category Filter Bar ── */}
// //       <Box sx={{ px:3, py:1.5, borderBottom:'1px solid #f1f5f9', display:'flex', gap:1, alignItems:'center', flexWrap:'wrap', backgroundColor:'#f8fafc' }}>
// //         <FilterList sx={{ fontSize:16, color:'#94a3b8' }} />
// //         <Typography sx={{ fontSize:12, color:'#94a3b8', fontWeight:600, mr:0.5 }}>Filter:</Typography>
// //         {[{ value:'ALL', label:'All' }, ...CATEGORY_CODES].map(cat => (
// //           <Chip 
// //             key={cat.value} 
// //             label={cat.label||cat.value} 
// //             variant="outlined" 
// //             size="small" 
// //             onClick={() => handleFilter(cat.value)}
// //             sx={{ 
// //               cursor:'pointer', 
// //               fontWeight:activeFilter===cat.value?700:400, 
// //               borderColor:activeFilter===cat.value?'#0ea5e9':'#e2e8f0', 
// //               color:activeFilter===cat.value?'#0ea5e9':'#64748b', 
// //               backgroundColor:activeFilter===cat.value?'rgba(14,165,233,0.08)':'#fff',
// //               '&:hover':{ borderColor:'#0ea5e9', color:'#0ea5e9' },
// //               transition:'all 0.15s',
// //             }}
// //           />
// //         ))}
// //       </Box>

// //       {/* ── Stats + Excel Bar ── */}
// //       <Box sx={{ 
// //         px:3, py:1.5, 
// //         display:'flex', 
// //         alignItems:'center', 
// //         justifyContent:'space-between', 
// //         borderBottom:'1px solid #f1f5f9',
// //         backgroundColor:'#fff',
// //         minHeight: 56,
// //       }}>
// //         {/* Stats */}
// //         <Box sx={{ display:'flex', gap:4, alignItems:'center', flexWrap:'wrap' }}>
// //           {[
// //             { label:'Total Items',     value: rows.length,                                                                    color:'#0ea5e9' },
// //             { label:'With QR',         value: rows.filter(r => r.qr_sticker_url).length,                                      color:'#10b981' },
// //             { label:'Assigned to FE',  value: rows.filter(r => r.fe || r.fe_name).length,                                     color:'#6366f1' },
// //             { label:'Damaged / Scrap', value: rows.filter(r => ['DAMAGED','SCRAP','OBSOLETE'].includes(r.condition)).length,   color:'#ef4444' },
// //           ].map(s => (
// //             <Box key={s.label} sx={{ display:'flex', alignItems:'baseline', gap:0.5 }}>
// //               <Typography sx={{ fontSize:22, fontWeight:800, color:s.color, lineHeight:1 }}>{s.value}</Typography>
// //               <Typography sx={{ fontSize:12, color:'#94a3b8' }}>{s.label}</Typography>
// //             </Box>
// //           ))}
// //         </Box>

// //         {/* Excel Download Button — always on the right */}
// //         <Button
// //           onClick={exportToExcel}
// //           disabled={rows.length === 0}
// //           startIcon={<DownloadIcon />}
// //           variant="contained"
// //           sx={{
// //             ml: 2,
// //             flexShrink: 0,
// //             whiteSpace: 'nowrap',
// //             fontWeight: 700,
// //             textTransform: 'none',
// //             borderRadius: 2,
// //             px: 2.5,
// //             py: 0.9,
// //             fontSize: 13,
// //             background: 'linear-gradient(135deg,#10b981,#059669)',
// //             boxShadow: '0 4px 14px rgba(16,185,129,0.35)',
// //             '&:hover': {
// //               background: 'linear-gradient(135deg,#047857,#065f46)',
// //               transform: 'translateY(-1px)',
// //               boxShadow: '0 6px 18px rgba(16,185,129,0.45)',
// //             },
// //             '&.Mui-disabled': {
// //               background: '#e2e8f0',
// //               color: '#94a3b8',
// //               boxShadow: 'none',
// //             },
// //             transition: 'all 0.2s',
// //           }}
// //         >
// //           Download Excel ({rows.length})
// //         </Button>
// //       </Box>

// //       {/* ── Table ── */}
// //       <TableComponent 
// //         columns={columns} 
// //         rows={rows} 
// //         manageColumnStatus 
// //         enableSort="true"
// //         sx={{ 
// //           '& .MuiDataGrid-columnHeaders':{
// //             backgroundColor:'#f8fafc', color:'#374151', fontWeight:700, fontSize:12, 
// //             borderBottom:'2px solid #e2e8f0'
// //           },
// //           '& .MuiDataGrid-row:hover':{ backgroundColor:'#f0f9ff' },
// //         }}
// //       />

// //       {/* ── Add / Edit Dialog ── */}
// //       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} 
// //         PaperProps={{ sx:{ borderRadius:3, minWidth:600, boxShadow:'0 25px 60px rgba(15,23,42,0.25)' } }}>
// //         <Box sx={{ 
// //           background:'linear-gradient(135deg,#0f172a,#1e3a5f)', color:'#fff', py:2, px:3, 
// //           display:'flex', justifyContent:'space-between', alignItems:'center',
// //         }}>
// //           <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
// //             <QrCode2 sx={{ color:'#0ea5e9', fontSize:22 }} />
// //             <Typography sx={{ fontWeight:700, fontSize:16 }}>
// //               {isEditMode ? 'Edit Movable Item' : 'Register Movable Item'}
// //             </Typography>
// //           </Box>
// //           <IconButton size="small" onClick={() => setOpenFormDialog(false)} sx={{ color:'rgba(255,255,255,0.6)' }}>
// //             <Close fontSize="small" />
// //           </IconButton>
// //         </Box>
        
// //         <DialogContent sx={{ px:3, py:2.5, maxHeight:'72vh', overflowY:'auto' }}>
// //           <SectionLabel>① Financial Establishment</SectionLabel>
// //           <Autocomplete 
// //             size="small" 
// //             options={feList} 
// //             loading={feLoading} 
// //             value={selectedFe}
// //             getOptionLabel={(opt) => opt?.name_of_fe || ''}
// //             isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
// //             onChange={(_, newVal) => {
// //               setSelectedFe(newVal);
// //               setFormData(p => ({ ...p, fe: newVal ? newVal.id : null }));
// //             }}
// //             renderInput={(params) => (
// //               <TextField 
// //                 {...params} 
// //                 label="Select Financial Establishment" 
// //                 placeholder="Search by name…"
// //                 InputProps={{
// //                   ...params.InputProps,
// //                   startAdornment: (
// //                     <>
// //                       <Person sx={{ fontSize:18, color:'#6366f1', mr:0.5 }} />
// //                       {params.InputProps.startAdornment}
// //                     </>
// //                   ),
// //                   endAdornment: (
// //                     <>
// //                       {feLoading ? <CircularProgress size={16} /> : null}
// //                       {params.InputProps.endAdornment}
// //                     </>
// //                   ),
// //                 }}
// //               />
// //             )}
// //             renderOption={(props, opt) => (
// //               <Box component="li" {...props} sx={{ display:'flex', alignItems:'center', gap:1.5, py:1 }}>
// //                 <Box sx={{ 
// //                   width:30, height:30, borderRadius:'50%', 
// //                   background:'linear-gradient(135deg,#6366f1,#8b5cf6)', 
// //                   display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
// //                 }}>
// //                   <Typography sx={{ color:'#fff', fontSize:12, fontWeight:700 }}>
// //                     {(opt.name_of_fe||'?')[0].toUpperCase()}
// //                   </Typography>
// //                 </Box>
// //                 <Box>
// //                   <Typography sx={{ fontSize:13, fontWeight:600 }}>{opt.name_of_fe}</Typography>
// //                   {opt.employee_id && (
// //                     <Typography sx={{ fontSize:11, color:'#94a3b8' }}>ID: {opt.employee_id}</Typography>
// //                   )}
// //                 </Box>
// //               </Box>
// //             )}
// //             sx={{ mb:2 }}
// //           />
// //           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

// //           <SectionLabel>② Coding Hierarchy</SectionLabel>
// //           <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:2 }}>
// //             <FormControl fullWidth size="small" error={!!formErrors.category_code}>
// //               <InputLabel>Category Code *</InputLabel>
// //               <Select 
// //                 label="Category Code *" 
// //                 value={formData.category_code} 
// //                 onChange={e => setFormData(p => ({ ...p, category_code:e.target.value }))}
// //               >
// //                 {CATEGORY_CODES.map(c => (
// //                   <MenuItem key={c.value} value={c.value}>
// //                     <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
// //                       <Box sx={{ width:8, height:8, borderRadius:'50%', backgroundColor:CATEGORY_COLORS[c.value] }} />
// //                       <span style={{ fontWeight:600 }}>{c.value}</span>
// //                       <span style={{ color:'#94a3b8', fontSize:12 }}>· {c.label}</span>
// //                     </Box>
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //               {formErrors.category_code && <FormHelperText>{formErrors.category_code}</FormHelperText>}
// //             </FormControl>
// //             <TextField size="small" label="Sub Code" placeholder="-SPL" {...f('sub_code')} />
// //             <TextField size="small" label="Object Code" placeholder="--LCD" {...f('object_code')} />
// //             <TextField size="small" label="Detail Code" placeholder="---KB" {...f('detail_code')} />
// //           </Box>

// //           {formData.category_code && (
// //             <Box sx={{ mb:2, px:2, py:1, borderRadius:1.5, backgroundColor:'#f8fafc', border:'1px solid #e2e8f0', display:'flex', alignItems:'center', gap:1 }}>
// //               <Typography sx={{ fontSize:11, color:'#94a3b8', fontWeight:600 }}>FULL CODE PREVIEW:</Typography>
// //               <Typography sx={{ fontFamily:'monospace', fontSize:13, fontWeight:700, color:'#0f172a' }}>
// //                 {formData.category_code}{formData.sub_code}{formData.object_code}{formData.detail_code}
// //               </Typography>
// //             </Box>
// //           )}
// //           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

// //           <SectionLabel>③ Item Details</SectionLabel>
// //           <Stack spacing={1.5} sx={{ mb:2 }}>
// //             <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5 }}>
// //               <TextField size="small" label="Item Name *" {...f('name_of_item')} />
// //               <TextField size="small" label="Make / Brand" {...f('make_brand')} />
// //               <TextField size="small" label="Serial No. of Item" {...f('serial_no_of_item')} />
// //               <TextField size="small" label="Serial No. of Group" {...f('serial_no_of_group')} />
// //             </Box>
// //             <TextField size="small" label="Description (material, colour, order)" multiline rows={2} {...f('description')} />
// //           </Stack>
// //           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

// //           <SectionLabel>④ Valuation & Condition</SectionLabel>
// //           <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:1.5 }}>
// //             <FormControl fullWidth size="small">
// //               <InputLabel>Rating</InputLabel>
// //               <Select label="Rating" value={formData.rating} onChange={e => setFormData(p => ({ ...p, rating:e.target.value }))}>
// //                 <MenuItem value=""><em>None</em></MenuItem>
// //                 {RATINGS.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
// //               </Select>
// //             </FormControl>
// //             <FormControl fullWidth size="small">
// //               <InputLabel>Condition</InputLabel>
// //               <Select label="Condition" value={formData.condition} onChange={e => setFormData(p => ({ ...p, condition:e.target.value }))}>
// //                 <MenuItem value=""><em>None</em></MenuItem>
// //                 {CONDITIONS.map(c => (
// //                   <MenuItem key={c} value={c}>
// //                     <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
// //                       <Box sx={{ width:8, height:8, borderRadius:'50%', backgroundColor:CONDITION_COLORS[c] }} />
// //                       {c}
// //                     </Box>
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Box>
// //           {['DAMAGED','OBSOLETE'].includes(formData.condition) && (
// //             <TextField size="small" fullWidth label="Condition Details" multiline rows={2} sx={{ mb:1.5 }} {...f('condition_details')} />
// //           )}
// //           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

// //           <SectionLabel>⑤ Photos (Point C – Image 4)</SectionLabel>
// //           <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:2 }}>
// //             <UploadBox 
// //               file={groupPhoto} 
// //               onChange={setGroupPhoto} 
// //               label="Group Photo" 
// //               existingUrl={isEditMode ? selectedItem?.group_photo_url : null} 
// //             />
// //             <UploadBox 
// //               file={samplePhoto} 
// //               onChange={setSamplePhoto} 
// //               label="Sample Photo" 
// //               existingUrl={isEditMode ? selectedItem?.sample_photo_url : null} 
// //             />
// //           </Box>

// //           <Box sx={{ 
// //             p:1.5, borderRadius:2, 
// //             background:'linear-gradient(135deg,rgba(14,165,233,0.08),rgba(99,102,241,0.08))', 
// //             border:'1px solid rgba(14,165,233,0.2)', display:'flex', alignItems:'center', gap:1.5,
// //           }}>
// //             <QrCode2 sx={{ color:'#0ea5e9', fontSize:28, flexShrink:0 }} />
// //             <Typography sx={{ fontSize:12, color:'#475569', lineHeight:1.5 }}>
// //               <strong style={{ color:'#0ea5e9' }}>QR Sticker auto-generated</strong> on save — contains Category Code, Item Name, Serial No. & Condition. Uploaded to S3 automatically.
// //             </Typography>
// //           </Box>
// //         </DialogContent>
        
// //         <DialogActions sx={{ px:3, py:2, borderTop:'1px solid #f1f5f9', gap:1 }}>
// //           <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading} 
// //             sx={{ color:'#64748b', textTransform:'none', fontWeight:600 }}>
// //             Cancel
// //           </Button>
// //           <Button onClick={handleSubmit} disabled={submitLoading} sx={{ 
// //             background:'linear-gradient(135deg,#0ea5e9,#2563eb)', color:'#fff', fontWeight:700, 
// //             textTransform:'none', px:3, borderRadius:2, 
// //             '&:hover':{ background:'linear-gradient(135deg,#0284c7,#1d4ed8)' },
// //           }}>
// //             {submitLoading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update & Regenerate QR' : 'Save & Generate QR'}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* ── Delete Confirmation ── */}
// //       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} 
// //         PaperProps={{ sx:{ borderRadius:3, minWidth:400, boxShadow:'0 25px 60px rgba(15,23,42,0.25)' } }}>
// //         <Box sx={{ 
// //           background:'linear-gradient(135deg,#7f1d1d,#991b1b)', color:'#fff', py:2, px:3, 
// //           display:'flex', justifyContent:'space-between', alignItems:'center',
// //         }}>
// //           <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
// //             <Delete sx={{ color:'#fca5a5', fontSize:20 }} />
// //             <Typography sx={{ fontWeight:700 }}>Confirm Delete</Typography>
// //           </Box>
// //           <IconButton size="small" onClick={() => setDeleteDialogOpen(false)} sx={{ color:'rgba(255,255,255,0.6)' }}>
// //             <Close fontSize="small" />
// //           </IconButton>
// //         </Box>
// //         <DialogContent sx={{ py:3, px:3 }}>
// //           <Typography sx={{ color:'#374151', mb:1.5 }}>
// //             Are you sure you want to delete this item?
// //           </Typography>
// //           {deleteItem && (
// //             <Box sx={{ p:1.5, borderRadius:2, backgroundColor:'#fef2f2', border:'1px solid #fecaca', mb:1.5 }}>
// //               <Typography sx={{ fontWeight:700, color:'#991b1b', fontSize:14 }}>
// //                 {deleteItem.name_of_item}
// //               </Typography>
// //               <Typography sx={{ fontSize:12, color:'#b91c1c', fontFamily:'monospace' }}>
// //                 {deleteItem.full_code}
// //               </Typography>
// //               {deleteItem.fe_name && (
// //                 <Typography sx={{ fontSize:11, color:'#6366f1', mt:0.5 }}>
// //                   Financial Establishment: {deleteItem.fe_name}
// //                 </Typography>
// //               )}
// //             </Box>
// //           )}
// //           <Typography sx={{ fontSize:12, color:'#ef4444' }}>
// //             ⚠ This will also delete the QR sticker and all photos from S3.
// //           </Typography>
// //         </DialogContent>
// //         <DialogActions sx={{ px:3, py:2, gap:1 }}>
// //           <Button onClick={() => setDeleteDialogOpen(false)} sx={{ color:'#64748b', textTransform:'none', fontWeight:600 }}>
// //             Cancel
// //           </Button>
// //           <Button onClick={handleDelete} variant="contained" color="error" sx={{ textTransform:'none', fontWeight:700, borderRadius:2 }}>
// //             Delete Permanently
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       <SnackBarComponent 
// //         open={snackbarOpen} 
// //         message={snackbarMessage} 
// //         severity={snackbarSeverity} 
// //         onClose={() => setSnackbarOpen(false)} 
// //       />
// //     </Box>
// //   );
// // };

// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions, DialogContent,
//   TextField, IconButton, MenuItem, Select, InputLabel, FormControl,
//   FormHelperText, Chip, Tooltip, Divider, Stack, Autocomplete,
//   CircularProgress,
// } from '@mui/material';
// import {
//   Delete, Edit, QrCode2, Add, FilterList, Inventory2, Close,
//   CloudUpload, Image as ImageIcon, Person, Download as DownloadIcon,
//   Business,
// } from '@mui/icons-material';
// import axios from 'axios';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import api from '../../api/axiosInterceptor';
// import { API_BASE_URL } from '../../config';
// import * as XLSX from 'xlsx';

// // ─── Constants ────────────────────────────────────────────────────────────────
// const CATEGORY_CODES = [
//   { value: 'AC',  label: 'Air Conditioners' },
//   { value: 'PCP', label: 'Computers & Peripherals' },
//   { value: 'EEG', label: 'Electrical & Electronic Goods' },
//   { value: 'FF',  label: 'Furniture & Fixtures' },
//   { value: 'MTP', label: 'Machinery, Tools & Plant' },
//   { value: 'TXT', label: 'Textiles' },
//   { value: 'VEH', label: 'Vehicles' },
//   { value: 'ANC', label: 'Art Objects & Handicrafts' },
// ];

// const RATINGS    = ['EXCLUSIVE', 'HIGH', 'AVERAGE', 'LOW'];
// const CONDITIONS = ['NEW','UNUSED','WORKING','DAMAGED','OBSOLETE','SCRAP','APPRECIATING','DEPRECIATING'];

// const CATEGORY_COLORS = {
//   AC:'#0ea5e9', PCP:'#8b5cf6', EEG:'#f59e0b', FF:'#10b981',
//   MTP:'#ef4444', TXT:'#ec4899', VEH:'#f97316', ANC:'#6366f1',
// };

// const CONDITION_COLORS = {
//   NEW:'#10b981', UNUSED:'#06b6d4', WORKING:'#3b82f6', DAMAGED:'#f59e0b',
//   OBSOLETE:'#6b7280', SCRAP:'#ef4444', APPRECIATING:'#8b5cf6', DEPRECIATING:'#f97316',
// };

// const EMPTY_FORM = {
//   category_code:'', sub_code:'', object_code:'', detail_code:'', serial_no_of_group:'',
//   name_of_item:'', serial_no_of_item:'', description:'', make_brand:'', rating:'',
//   condition:'', condition_details:'', fe: null,
// };

// // ─── Hook: fetch FE list ──────────────────────────────────────────────────────
// const useFetchFeBaseList = () => {
//   const [list, setList]       = useState([]);
//   const [loading, setLoading] = useState(false);
//   useEffect(() => {
//     setLoading(true);
//     axios.get(`${API_BASE_URL}/fe-mgmt/fe-base/`)
//       .then(res => setList(res.data || []))
//       .catch(() => setList([]))
//       .finally(() => setLoading(false));
//   }, []);
//   return { list, loading };
// };

// // ─── Sub-components ───────────────────────────────────────────────────────────
// const CategoryBadge = ({ code }) => (
//   <Box sx={{
//     display:'inline-flex', alignItems:'center', gap:0.5, px:1.2, py:0.3,
//     borderRadius:1.5, backgroundColor:`${CATEGORY_COLORS[code]||'#6b7280'}18`,
//     border:`1px solid ${CATEGORY_COLORS[code]||'#6b7280'}40`,
//   }}>
//     <Box sx={{ width:6, height:6, borderRadius:'50%', backgroundColor:CATEGORY_COLORS[code]||'#6b7280' }} />
//     <Typography sx={{ fontSize:12, fontWeight:700, color:CATEGORY_COLORS[code]||'#6b7280' }}>{code}</Typography>
//   </Box>
// );

// const ConditionBadge = ({ condition }) => (
//   <Chip label={condition||'—'} size="small" sx={{
//     fontSize:11, fontWeight:600, height:22,
//     backgroundColor:`${CONDITION_COLORS[condition]||'#6b7280'}18`,
//     color:CONDITION_COLORS[condition]||'#6b7280',
//     border:`1px solid ${CONDITION_COLORS[condition]||'#6b7280'}40`,
//   }} />
// );

// const FeBadge = ({ feObj, feId, feName }) => {
//   const name = feObj?.name_of_fe || feName || feId || '—';
//   return name !== '—' ? (
//     <Box sx={{
//       display:'inline-flex', alignItems:'center', gap:0.5, px:1.2, py:0.3,
//       borderRadius:1.5, backgroundColor:'rgba(99,102,241,0.1)',
//       border:'1px solid rgba(99,102,241,0.3)',
//     }}>
//       <Person sx={{ fontSize:12, color:'#6366f1' }} />
//       <Typography sx={{ fontSize:12, fontWeight:600, color:'#6366f1' }}>
//         {typeof name === 'object' ? name.name_of_fe || name : name}
//       </Typography>
//     </Box>
//   ) : (
//     <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>
//   );
// };

// const UploadBox = ({ file, onChange, existingUrl, label }) => (
//   <Box>
//     <Typography sx={{ fontSize:11, color:'#64748b', mb:0.5, fontWeight:600 }}>{label}</Typography>
//     <Box component="label" sx={{
//       border:`2px dashed ${file ? '#0ea5e9' : '#cbd5e1'}`, borderRadius:2, p:2,
//       textAlign:'center', cursor:'pointer',
//       backgroundColor: file ? 'rgba(14,165,233,0.04)' : '#f8fafc',
//       display:'block', transition:'all 0.2s',
//       '&:hover':{ borderColor:'#0ea5e9', backgroundColor:'rgba(14,165,233,0.04)' },
//     }}>
//       <input type="file" accept="image/*" hidden onChange={e => onChange(e.target.files[0])} />
//       <CloudUpload sx={{ fontSize:26, color:file?'#0ea5e9':'#cbd5e1', mb:0.5 }} />
//       <Typography sx={{ fontSize:12, color:file?'#0ea5e9':'#94a3b8', fontWeight:600, wordBreak:'break-all' }}>
//         {file ? file.name : 'Click to upload'}
//       </Typography>
//     </Box>
//     {!file && existingUrl && (
//       <Typography sx={{ fontSize:11, color:'#10b981', mt:0.5 }}>
//         ✓ <a href={existingUrl} target="_blank" rel="noreferrer" style={{ color:'#10b981' }}>Current photo</a>
//       </Typography>
//     )}
//   </Box>
// );

// const SectionLabel = ({ children }) => (
//   <Typography sx={{
//     fontSize:11, fontWeight:700, letterSpacing:1.2, color:'#94a3b8',
//     textTransform:'uppercase', mb:1.5,
//   }}>
//     {children}
//   </Typography>
// );

// // ─── Main Component ───────────────────────────────────────────────────────────
// export const MovableItemsComponent = () => {
//   const { list: feList, loading: feLoading } = useFetchFeBaseList();

//   const [rows, setRows]                         = useState([]);
//   const [loading, setLoading]                   = useState(false);
//   const [submitLoading, setSubmitLoading]       = useState(false);

//   // ── Filters: FE must be selected first ───────────────────────────────────
//   const [activeFeFilter, setActiveFeFilter]             = useState(null);
//   const [activeCategoryFilter, setActiveCategoryFilter] = useState('ALL');

//   const [snackbarOpen, setSnackbarOpen]         = useState(false);
//   const [snackbarMessage, setSnackbarMessage]   = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');
//   const [openFormDialog, setOpenFormDialog]     = useState(false);
//   const [isEditMode, setIsEditMode]             = useState(false);
//   const [selectedItem, setSelectedItem]         = useState(null);
//   const [formData, setFormData]                 = useState(EMPTY_FORM);
//   const [formErrors, setFormErrors]             = useState({});
//   const [groupPhoto, setGroupPhoto]             = useState(null);
//   const [samplePhoto, setSamplePhoto]           = useState(null);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteItem, setDeleteItem]             = useState(null);
//   const [selectedFe, setSelectedFe]             = useState(null);

//   // ── Fetch: only runs when FE is selected ─────────────────────────────────
//   const fetchItems = useCallback((feId, categoryCode = 'ALL') => {
//     if (!feId) return;
//     setLoading(true);
//     const params = new URLSearchParams();
//     params.append('fe', feId);
//     if (categoryCode && categoryCode !== 'ALL') params.append('category_code', categoryCode);
//     api.get(`/evalueM/movable-items/?${params.toString()}`)
//       .then(res => setRows(res.data.map((item, i) => ({ ...item, slNo: i + 1 }))))
//       .catch(() => showSnackbar('Failed to load movable items.', 'error'))
//       .finally(() => setLoading(false));
//   }, []);

//   const showSnackbar = (msg, sev = 'info') => {
//     setSnackbarMessage(msg); setSnackbarSeverity(sev); setSnackbarOpen(true);
//   };

//   // FE chip clicked → reset category, reload
//   const handleFeFilter = (fe) => {
//     setActiveFeFilter(fe);
//     setActiveCategoryFilter('ALL');
//     setRows([]);
//     fetchItems(fe.id, 'ALL');
//   };

//   // Category chip clicked (only if FE already chosen)
//   const handleCategoryFilter = (code) => {
//     if (!activeFeFilter) return;
//     setActiveCategoryFilter(code);
//     fetchItems(activeFeFilter.id, code);
//   };

//   // ── Excel Export ──────────────────────────────────────────────────────────
//   const exportToExcel = useCallback(() => {
//     const headers = [
//       'Sl No.', 'Category', 'Full Code', 'Item Name', 'Serial No.',
//       'Make/Brand', 'Financial Establishment', 'Condition', 'Rating',
//       'QR Sticker Link', 'Group Photo Link', 'Sample Photo Link',
//     ];

//     const excelData = rows.map((row) => ({
//       'Sl No.':                  row.slNo,
//       'Category':                row.category_code || '',
//       'Full Code':               row.full_code || '',
//       'Item Name':               row.name_of_item || '',
//       'Serial No.':              row.serial_no_of_item || '',
//       'Make/Brand':              row.make_brand || '',
//       'Financial Establishment': row.fe_name || row.fe?.name_of_fe || '',
//       'Condition':               row.condition || '',
//       'Rating':                  row.rating || '',
//       'QR Sticker Link':         row.qr_sticker_url || '',
//       'Group Photo Link':        row.group_photo_url || '',
//       'Sample Photo Link':       row.sample_photo_url || '',
//     }));

//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.json_to_sheet(excelData, { header: headers });

//     ws['!cols'] = [
//       { wch: 8 }, { wch: 12 }, { wch: 22 }, { wch: 25 }, { wch: 15 },
//       { wch: 18 }, { wch: 32 }, { wch: 14 }, { wch: 12 },
//       { wch: 55 }, { wch: 55 }, { wch: 55 },
//     ];

//     // Clickable hyperlinks for QR (col 9), Group Photo (col 10), Sample Photo (col 11)
//     [
//       { colIndex: 9,  field: 'qr_sticker_url' },
//       { colIndex: 10, field: 'group_photo_url' },
//       { colIndex: 11, field: 'sample_photo_url' },
//     ].forEach(({ colIndex, field }) => {
//       rows.forEach((row, rowIndex) => {
//         const url = row[field];
//         if (url) {
//           const cellRef = XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex });
//           if (ws[cellRef]) {
//             ws[cellRef].l = { Target: url, Tooltip: url };
//             ws[cellRef].s = { font: { color: { rgb: '0563C1' }, underline: true } };
//           }
//         }
//       });
//     });

//     XLSX.utils.book_append_sheet(wb, ws, 'Movable Items');
//     XLSX.writeFile(wb, `Movable_Items_${new Date().toISOString().slice(0, 10)}.xlsx`);
//     showSnackbar('Excel downloaded successfully!', 'success');
//   }, [rows]);

//   // ── Columns ───────────────────────────────────────────────────────────────
//   const columns = [
//     { id:'slNo', field:'slNo', headerName:'Sl No.', width:70 },
//     {
//       id:'category_code', field:'category_code', headerName:'Category', width:110,
//       renderCell:(p) => <CategoryBadge code={p.value} />,
//     },
//     {
//       id:'full_code', field:'full_code', headerName:'Full Code', width:170,
//       renderCell:(p) => (
//         <Typography sx={{ fontFamily:'monospace', fontSize:12, color:'#475569', fontWeight:600 }}>
//           {p.value}
//         </Typography>
//       ),
//     },
//     { id:'name_of_item', field:'name_of_item', headerName:'Item Name', width:190 },
//     { id:'serial_no_of_item', field:'serial_no_of_item', headerName:'Serial No.', width:120 },
//     { id:'make_brand', field:'make_brand', headerName:'Make/Brand', width:130 },
//     {
//       id:'fe_name', field:'fe_name', headerName:'Financial Establishment', width:220,
//       renderCell:(p) => {
//         const row = p.row;
//         return <FeBadge feObj={row.fe} feId={row.fe} feName={row.fe_name || row.fe?.name_of_fe} />;
//       },
//     },
//     {
//       id:'condition', field:'condition', headerName:'Condition', width:130,
//       renderCell:(p) => <ConditionBadge condition={p.value} />,
//     },
//     {
//       id:'rating', field:'rating', headerName:'Rating', width:95,
//       renderCell:(p) => (
//         <Typography sx={{ fontSize:12, fontWeight:600, color:'#64748b' }}>{p.value||'—'}</Typography>
//       ),
//     },
//     {
//       id:'qr_sticker_url', field:'qr_sticker_url', headerName:'QR', width:65,
//       renderCell:(p) => p.value ? (
//         <Tooltip title="View QR Sticker" arrow>
//           <IconButton size="small" onClick={() => window.open(p.value,'_blank')}
//             sx={{ color:'#0ea5e9','&:hover':{ backgroundColor:'rgba(14,165,233,0.1)' } }}>
//             <QrCode2 fontSize="small" />
//           </IconButton>
//         </Tooltip>
//       ) : <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>,
//     },
//     {
//       id:'photos', field:'photos', headerName:'Photos', width:75,
//       renderCell:(p) => {
//         const row = p.row;
//         if (!row.group_photo_url && !row.sample_photo_url)
//           return <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>;
//         return (
//           <Box sx={{ display:'flex', gap:0.25, flexDirection:'column' }}>
//             {row.group_photo_url && (
//               <Tooltip title="Group Photo" arrow>
//                 <IconButton size="small" onClick={() => window.open(row.group_photo_url,'_blank')}
//                   sx={{ color:'#10b981','&:hover':{ backgroundColor:'rgba(16,185,129,0.1)' }, p:0.25 }}>
//                   <ImageIcon fontSize="small" />
//                 </IconButton>
//               </Tooltip>
//             )}
//             {row.sample_photo_url && (
//               <Tooltip title="Sample Photo" arrow>
//                 <IconButton size="small" onClick={() => window.open(row.sample_photo_url,'_blank')}
//                   sx={{ color:'#3b82f6','&:hover':{ backgroundColor:'rgba(59,130,246,0.1)' }, p:0.25 }}>
//                   <ImageIcon fontSize="small" />
//                 </IconButton>
//               </Tooltip>
//             )}
//           </Box>
//         );
//       },
//     },
//     {
//       id:'actions', field:'actions', headerName:'Actions', width:100,
//       renderCell:(p) => (
//         <Box sx={{ display:'flex', gap:0.5 }}>
//           <Tooltip title="Edit" arrow>
//             <IconButton size="small" onClick={() => handleEdit(p.row)}
//               sx={{ color:'#3b82f6','&:hover':{ backgroundColor:'rgba(59,130,246,0.1)' } }}>
//               <Edit fontSize="small" />
//             </IconButton>
//           </Tooltip>
//           <Tooltip title="Delete" arrow>
//             <IconButton size="small" onClick={() => handleDeleteConfirmation(p.row)}
//               sx={{ color:'#ef4444','&:hover':{ backgroundColor:'rgba(239,68,68,0.1)' } }}>
//               <Delete fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       ),
//     },
//   ];

//   // ── CRUD ──────────────────────────────────────────────────────────────────
//   const handleAdd = () => {
//     setIsEditMode(false); setFormData(EMPTY_FORM); setSelectedFe(null);
//     setGroupPhoto(null); setSamplePhoto(null); setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (item) => {
//     setIsEditMode(true); setSelectedItem(item);
//     setFormData({
//       category_code: item.category_code||'', sub_code: item.sub_code||'',
//       object_code: item.object_code||'', detail_code: item.detail_code||'',
//       serial_no_of_group: item.serial_no_of_group||'', name_of_item: item.name_of_item||'',
//       serial_no_of_item: item.serial_no_of_item||'', description: item.description||'',
//       make_brand: item.make_brand||'', rating: item.rating||'',
//       condition: item.condition||'', condition_details: item.condition_details||'',
//       fe: item.fe||null,
//     });
//     const matchedFe = feList.find(f => f.id === item.fe) || null;
//     setSelectedFe(matchedFe || (item.fe_name ? { id:item.fe, name_of_fe:item.fe_name } : null));
//     setGroupPhoto(null); setSamplePhoto(null); setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (item) => { setDeleteItem(item); setDeleteDialogOpen(true); };

//   const handleDelete = () => {
//     api.delete(`/evalueM/movable-items/${deleteItem.id}/`)
//       .then(() => {
//         showSnackbar('Item deleted successfully.', 'success');
//         fetchItems(activeFeFilter?.id, activeCategoryFilter);
//       })
//       .catch(() => showSnackbar('Failed to delete item.', 'error'))
//       .finally(() => { setDeleteDialogOpen(false); setDeleteItem(null); });
//   };

//   const validate = () => {
//     const e = {};
//     if (!formData.category_code)        e.category_code = 'Category is required';
//     if (!formData.name_of_item?.trim()) e.name_of_item  = 'Item name is required';
//     setFormErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const handleSubmit = () => {
//     if (!validate()) return;
//     setSubmitLoading(true);
//     const form = new FormData();
//     Object.entries(formData).forEach(([k, v]) => { if (v !== null && v !== undefined) form.append(k, v); });
//     if (groupPhoto)  form.append('group_photo_url', groupPhoto);
//     if (samplePhoto) form.append('sample_photo_url', samplePhoto);
//     const req = isEditMode
//       ? api.patch(`/evalueM/movable-items/${selectedItem.id}/`, form, { headers:{ 'Content-Type':'multipart/form-data' } })
//       : api.post(`/evalueM/movable-items/`, form, { headers:{ 'Content-Type':'multipart/form-data' } });
//     req
//       .then(() => {
//         showSnackbar(`Item ${isEditMode ? 'updated' : 'added'} & QR sticker generated!`, 'success');
//         fetchItems(activeFeFilter?.id, activeCategoryFilter);
//       })
//       .catch(() => showSnackbar(`Failed to ${isEditMode ? 'update' : 'add'} item.`, 'error'))
//       .finally(() => { setSubmitLoading(false); setOpenFormDialog(false); });
//   };

//   const f = (key) => ({
//     value: formData[key], error: !!formErrors[key], helperText: formErrors[key],
//     onChange: (e) => setFormData(p => ({ ...p, [key]: e.target.value })),
//   });

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ width:'100%', mt:8, mb:1, borderRadius:3, overflow:'visible', boxShadow:'0 8px 32px rgba(15,23,42,0.12)', backgroundColor:'#fff' }}>

//       {/* ── Header ── */}
//       <Box sx={{
//         background:'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #0284c7 100%)',
//         px:3, py:2.5, display:'flex', justifyContent:'space-between', alignItems:'center',
//         flexWrap:'wrap', gap:1.5, borderRadius:'12px 12px 0 0',
//       }}>
//         <Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
//           <Box sx={{
//             width:48, height:48, borderRadius:2,
//             background:'rgba(14,165,233,0.2)', border:'1px solid rgba(14,165,233,0.4)',
//             display:'flex', alignItems:'center', justifyContent:'center',
//           }}>
//             <Inventory2 sx={{ color:'#0ea5e9', fontSize:26 }} />
//           </Box>
//           <Box>
//             <Typography sx={{ color:'#fff', fontWeight:800, fontSize:20, letterSpacing:-0.5 }}>
//               Movable Assets
//             </Typography>
//             <Typography sx={{ color:'rgba(255,255,255,0.45)', fontSize:12 }}>
//               eValueM · QR Coding & Valuation Module
//             </Typography>
//           </Box>
//         </Box>
//         <Button
//           startIcon={<Add />}
//           onClick={handleAdd}
//           sx={{
//             background:'linear-gradient(135deg,#0ea5e9,#2563eb)', color:'#fff', fontWeight:700,
//             borderRadius:2, px:2.5, py:1, textTransform:'none', whiteSpace:'nowrap', flexShrink:0,
//             boxShadow:'0 4px 14px rgba(14,165,233,0.4)',
//             '&:hover':{ background:'linear-gradient(135deg,#0284c7,#1d4ed8)', transform:'translateY(-1px)' },
//             transition:'all 0.2s',
//           }}
//         >
//           Add Item
//         </Button>
//       </Box>

//       {/* ── FE Filter Bar ── */}
//       <Box sx={{ px:3, py:1.5, borderBottom:'1px solid #f1f5f9', backgroundColor:'#fafaff' }}>
//         <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
//           <Business sx={{ fontSize:15, color:'#6366f1' }} />
//           <Typography sx={{ fontSize:12, color:'#6366f1', fontWeight:700 }}>
//             Financial Establishment
//           </Typography>
//           {!activeFeFilter && (
//             <Typography sx={{ fontSize:11, color:'#f59e0b', fontWeight:600, ml:1 }}>
//               ← Select one to load data
//             </Typography>
//           )}
//           {activeFeFilter && (
//             <Chip
//               label="Clear"
//               size="small"
//               onClick={() => { setActiveFeFilter(null); setActiveCategoryFilter('ALL'); setRows([]); }}
//               sx={{ ml:1, fontSize:11, height:20, cursor:'pointer', color:'#ef4444', borderColor:'#ef4444', backgroundColor:'rgba(239,68,68,0.08)', border:'1px solid' }}
//             />
//           )}
//         </Box>
//         <Box sx={{ display:'flex', gap:1, flexWrap:'wrap' }}>
//           {feLoading ? (
//             <CircularProgress size={18} sx={{ color:'#6366f1' }} />
//           ) : feList.length === 0 ? (
//             <Typography sx={{ fontSize:12, color:'#94a3b8' }}>No FE found</Typography>
//           ) : (
//             feList.map(fe => {
//               const isActive = activeFeFilter?.id === fe.id;
//               return (
//                 <Chip
//                   key={fe.id}
//                   label={fe.name_of_fe}
//                   size="small"
//                   icon={<Person style={{ fontSize:13, color: isActive ? '#6366f1' : '#94a3b8' }} />}
//                   onClick={() => handleFeFilter(fe)}
//                   sx={{
//                     cursor:'pointer',
//                     fontWeight: isActive ? 700 : 400,
//                     border: '1px solid',
//                     borderColor: isActive ? '#6366f1' : '#e2e8f0',
//                     color: isActive ? '#6366f1' : '#64748b',
//                     backgroundColor: isActive ? 'rgba(99,102,241,0.1)' : '#fff',
//                     '&:hover':{ borderColor:'#6366f1', color:'#6366f1', backgroundColor:'rgba(99,102,241,0.06)' },
//                     transition:'all 0.15s',
//                   }}
//                 />
//               );
//             })
//           )}
//         </Box>
//       </Box>

//       {/* ── Category Filter Bar (only visible after FE selected) ── */}
//       {activeFeFilter && (
//         <Box sx={{ px:3, py:1.5, borderBottom:'1px solid #f1f5f9', display:'flex', gap:1, alignItems:'center', flexWrap:'wrap', backgroundColor:'#f8fafc' }}>
//           <FilterList sx={{ fontSize:16, color:'#94a3b8' }} />
//           <Typography sx={{ fontSize:12, color:'#94a3b8', fontWeight:600, mr:0.5 }}>Category:</Typography>
//           {[{ value:'ALL', label:'All' }, ...CATEGORY_CODES].map(cat => (
//             <Chip
//               key={cat.value}
//               label={cat.label || cat.value}
//               variant="outlined"
//               size="small"
//               onClick={() => handleCategoryFilter(cat.value)}
//               sx={{
//                 cursor:'pointer',
//                 fontWeight: activeCategoryFilter === cat.value ? 700 : 400,
//                 borderColor: activeCategoryFilter === cat.value ? '#0ea5e9' : '#e2e8f0',
//                 color: activeCategoryFilter === cat.value ? '#0ea5e9' : '#64748b',
//                 backgroundColor: activeCategoryFilter === cat.value ? 'rgba(14,165,233,0.08)' : '#fff',
//                 '&:hover':{ borderColor:'#0ea5e9', color:'#0ea5e9' },
//                 transition:'all 0.15s',
//               }}
//             />
//           ))}
//         </Box>
//       )}

//       {/* ── Stats + Excel Bar ── */}
//       <Box sx={{
//         px:3, py:1.5, display:'flex', alignItems:'center',
//         justifyContent:'space-between', borderBottom:'1px solid #f1f5f9',
//         backgroundColor:'#fff', minHeight:56,
//       }}>
//         <Box sx={{ display:'flex', gap:4, alignItems:'center', flexWrap:'wrap' }}>
//           {[
//             { label:'Total Items',     value: rows.length,                                                                   color:'#0ea5e9' },
//             { label:'With QR',         value: rows.filter(r => r.qr_sticker_url).length,                                     color:'#10b981' },
//             { label:'Assigned to FE',  value: rows.filter(r => r.fe || r.fe_name).length,                                    color:'#6366f1' },
//             { label:'Damaged / Scrap', value: rows.filter(r => ['DAMAGED','SCRAP','OBSOLETE'].includes(r.condition)).length,  color:'#ef4444' },
//           ].map(s => (
//             <Box key={s.label} sx={{ display:'flex', alignItems:'baseline', gap:0.5 }}>
//               <Typography sx={{ fontSize:22, fontWeight:800, color:s.color, lineHeight:1 }}>{s.value}</Typography>
//               <Typography sx={{ fontSize:12, color:'#94a3b8' }}>{s.label}</Typography>
//             </Box>
//           ))}
//         </Box>

//         <Button
//           onClick={exportToExcel}
//           disabled={rows.length === 0}
//           startIcon={<DownloadIcon />}
//           variant="contained"
//           sx={{
//             ml:2, flexShrink:0, whiteSpace:'nowrap', fontWeight:700,
//             textTransform:'none', borderRadius:2, px:2.5, py:0.9, fontSize:13,
//             background:'linear-gradient(135deg,#10b981,#059669)',
//             boxShadow:'0 4px 14px rgba(16,185,129,0.35)',
//             '&:hover':{ background:'linear-gradient(135deg,#047857,#065f46)', transform:'translateY(-1px)' },
//             '&.Mui-disabled':{ background:'#e2e8f0', color:'#94a3b8', boxShadow:'none' },
//             transition:'all 0.2s',
//           }}
//         >
//           Download Excel ({rows.length})
//         </Button>
//       </Box>

//       {/* ── Body ── */}
//       {!activeFeFilter ? (
//         // Prompt: select FE first
//         <Box sx={{ py:10, display:'flex', flexDirection:'column', alignItems:'center', gap:2 }}>
//           <Business sx={{ fontSize:64, color:'#e2e8f0' }} />
//           <Typography sx={{ fontSize:17, fontWeight:700, color:'#94a3b8' }}>
//             Select a Financial Establishment
//           </Typography>
//           <Typography sx={{ fontSize:13, color:'#cbd5e1' }}>
//             Choose an FE from the filter above to load its movable assets.
//           </Typography>
//         </Box>
//       ) : loading ? (
//         <Box sx={{ py:8, display:'flex', justifyContent:'center' }}>
//           <LoadingSpinner size={30} />
//         </Box>
//       ) : (
//         <TableComponent
//           columns={columns}
//           rows={rows}
//           manageColumnStatus
//           enableSort="true"
//           sx={{
//             '& .MuiDataGrid-columnHeaders':{ backgroundColor:'#f8fafc', color:'#374151', fontWeight:700, fontSize:12, borderBottom:'2px solid #e2e8f0' },
//             '& .MuiDataGrid-row:hover':{ backgroundColor:'#f0f9ff' },
//           }}
//         />
//       )}

//       {/* ── Add / Edit Dialog ── */}
//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}
//         PaperProps={{ sx:{ borderRadius:3, minWidth:600, boxShadow:'0 25px 60px rgba(15,23,42,0.25)' } }}>
//         <Box sx={{
//           background:'linear-gradient(135deg,#0f172a,#1e3a5f)', color:'#fff', py:2, px:3,
//           display:'flex', justifyContent:'space-between', alignItems:'center',
//         }}>
//           <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
//             <QrCode2 sx={{ color:'#0ea5e9', fontSize:22 }} />
//             <Typography sx={{ fontWeight:700, fontSize:16 }}>
//               {isEditMode ? 'Edit Movable Item' : 'Register Movable Item'}
//             </Typography>
//           </Box>
//           <IconButton size="small" onClick={() => setOpenFormDialog(false)} sx={{ color:'rgba(255,255,255,0.6)' }}>
//             <Close fontSize="small" />
//           </IconButton>
//         </Box>

//         <DialogContent sx={{ px:3, py:2.5, maxHeight:'72vh', overflowY:'auto' }}>
//           <SectionLabel>① Financial Establishment</SectionLabel>
//           <Autocomplete
//             size="small" options={feList} loading={feLoading} value={selectedFe}
//             getOptionLabel={(opt) => opt?.name_of_fe || ''}
//             isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
//             onChange={(_, newVal) => {
//               setSelectedFe(newVal);
//               setFormData(p => ({ ...p, fe: newVal ? newVal.id : null }));
//             }}
//             renderInput={(params) => (
//               <TextField {...params} label="Select Financial Establishment" placeholder="Search by name…"
//                 InputProps={{
//                   ...params.InputProps,
//                   startAdornment: (<><Person sx={{ fontSize:18, color:'#6366f1', mr:0.5 }} />{params.InputProps.startAdornment}</>),
//                   endAdornment: (<>{feLoading ? <CircularProgress size={16} /> : null}{params.InputProps.endAdornment}</>),
//                 }}
//               />
//             )}
//             renderOption={(props, opt) => (
//               <Box component="li" {...props} sx={{ display:'flex', alignItems:'center', gap:1.5, py:1 }}>
//                 <Box sx={{ width:30, height:30, borderRadius:'50%', background:'linear-gradient(135deg,#6366f1,#8b5cf6)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
//                   <Typography sx={{ color:'#fff', fontSize:12, fontWeight:700 }}>{(opt.name_of_fe||'?')[0].toUpperCase()}</Typography>
//                 </Box>
//                 <Box>
//                   <Typography sx={{ fontSize:13, fontWeight:600 }}>{opt.name_of_fe}</Typography>
//                   {opt.employee_id && <Typography sx={{ fontSize:11, color:'#94a3b8' }}>ID: {opt.employee_id}</Typography>}
//                 </Box>
//               </Box>
//             )}
//             sx={{ mb:2 }}
//           />
//           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

//           <SectionLabel>② Coding Hierarchy</SectionLabel>
//           <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:2 }}>
//             <FormControl fullWidth size="small" error={!!formErrors.category_code}>
//               <InputLabel>Category Code *</InputLabel>
//               <Select label="Category Code *" value={formData.category_code}
//                 onChange={e => setFormData(p => ({ ...p, category_code:e.target.value }))}>
//                 {CATEGORY_CODES.map(c => (
//                   <MenuItem key={c.value} value={c.value}>
//                     <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
//                       <Box sx={{ width:8, height:8, borderRadius:'50%', backgroundColor:CATEGORY_COLORS[c.value] }} />
//                       <span style={{ fontWeight:600 }}>{c.value}</span>
//                       <span style={{ color:'#94a3b8', fontSize:12 }}>· {c.label}</span>
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//               {formErrors.category_code && <FormHelperText>{formErrors.category_code}</FormHelperText>}
//             </FormControl>
//             <TextField size="small" label="Sub Code" placeholder="-SPL" {...f('sub_code')} />
//             <TextField size="small" label="Object Code" placeholder="--LCD" {...f('object_code')} />
//             <TextField size="small" label="Detail Code" placeholder="---KB" {...f('detail_code')} />
//           </Box>
//           {formData.category_code && (
//             <Box sx={{ mb:2, px:2, py:1, borderRadius:1.5, backgroundColor:'#f8fafc', border:'1px solid #e2e8f0', display:'flex', alignItems:'center', gap:1 }}>
//               <Typography sx={{ fontSize:11, color:'#94a3b8', fontWeight:600 }}>FULL CODE PREVIEW:</Typography>
//               <Typography sx={{ fontFamily:'monospace', fontSize:13, fontWeight:700, color:'#0f172a' }}>
//                 {formData.category_code}{formData.sub_code}{formData.object_code}{formData.detail_code}
//               </Typography>
//             </Box>
//           )}
//           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

//           <SectionLabel>③ Item Details</SectionLabel>
//           <Stack spacing={1.5} sx={{ mb:2 }}>
//             <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5 }}>
//               <TextField size="small" label="Item Name *" {...f('name_of_item')} />
//               <TextField size="small" label="Make / Brand" {...f('make_brand')} />
//               <TextField size="small" label="Serial No. of Item" {...f('serial_no_of_item')} />
//               <TextField size="small" label="Serial No. of Group" {...f('serial_no_of_group')} />
//             </Box>
//             <TextField size="small" label="Description (material, colour, order)" multiline rows={2} {...f('description')} />
//           </Stack>
//           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

//           <SectionLabel>④ Valuation & Condition</SectionLabel>
//           <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:1.5 }}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Rating</InputLabel>
//               <Select label="Rating" value={formData.rating} onChange={e => setFormData(p => ({ ...p, rating:e.target.value }))}>
//                 <MenuItem value=""><em>None</em></MenuItem>
//                 {RATINGS.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
//               </Select>
//             </FormControl>
//             <FormControl fullWidth size="small">
//               <InputLabel>Condition</InputLabel>
//               <Select label="Condition" value={formData.condition} onChange={e => setFormData(p => ({ ...p, condition:e.target.value }))}>
//                 <MenuItem value=""><em>None</em></MenuItem>
//                 {CONDITIONS.map(c => (
//                   <MenuItem key={c} value={c}>
//                     <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
//                       <Box sx={{ width:8, height:8, borderRadius:'50%', backgroundColor:CONDITION_COLORS[c] }} />
//                       {c}
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>
//           {['DAMAGED','OBSOLETE'].includes(formData.condition) && (
//             <TextField size="small" fullWidth label="Condition Details" multiline rows={2} sx={{ mb:1.5 }} {...f('condition_details')} />
//           )}
//           <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

//           <SectionLabel>⑤ Photos</SectionLabel>
//           <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:2 }}>
//             <UploadBox file={groupPhoto} onChange={setGroupPhoto} label="Group Photo" existingUrl={isEditMode ? selectedItem?.group_photo_url : null} />
//             <UploadBox file={samplePhoto} onChange={setSamplePhoto} label="Sample Photo" existingUrl={isEditMode ? selectedItem?.sample_photo_url : null} />
//           </Box>
//           <Box sx={{
//             p:1.5, borderRadius:2,
//             background:'linear-gradient(135deg,rgba(14,165,233,0.08),rgba(99,102,241,0.08))',
//             border:'1px solid rgba(14,165,233,0.2)', display:'flex', alignItems:'center', gap:1.5,
//           }}>
//             <QrCode2 sx={{ color:'#0ea5e9', fontSize:28, flexShrink:0 }} />
//             <Typography sx={{ fontSize:12, color:'#475569', lineHeight:1.5 }}>
//               <strong style={{ color:'#0ea5e9' }}>QR Sticker auto-generated</strong> on save — contains Category Code, Item Name, Serial No. & Condition. Uploaded to S3 automatically.
//             </Typography>
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ px:3, py:2, borderTop:'1px solid #f1f5f9', gap:1 }}>
//           <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}
//             sx={{ color:'#64748b', textTransform:'none', fontWeight:600 }}>
//             Cancel
//           </Button>
//           <Button onClick={handleSubmit} disabled={submitLoading} sx={{
//             background:'linear-gradient(135deg,#0ea5e9,#2563eb)', color:'#fff', fontWeight:700,
//             textTransform:'none', px:3, borderRadius:2,
//             '&:hover':{ background:'linear-gradient(135deg,#0284c7,#1d4ed8)' },
//           }}>
//             {submitLoading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update & Regenerate QR' : 'Save & Generate QR'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* ── Delete Confirmation ── */}
//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}
//         PaperProps={{ sx:{ borderRadius:3, minWidth:400, boxShadow:'0 25px 60px rgba(15,23,42,0.25)' } }}>
//         <Box sx={{
//           background:'linear-gradient(135deg,#7f1d1d,#991b1b)', color:'#fff', py:2, px:3,
//           display:'flex', justifyContent:'space-between', alignItems:'center',
//         }}>
//           <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
//             <Delete sx={{ color:'#fca5a5', fontSize:20 }} />
//             <Typography sx={{ fontWeight:700 }}>Confirm Delete</Typography>
//           </Box>
//           <IconButton size="small" onClick={() => setDeleteDialogOpen(false)} sx={{ color:'rgba(255,255,255,0.6)' }}>
//             <Close fontSize="small" />
//           </IconButton>
//         </Box>
//         <DialogContent sx={{ py:3, px:3 }}>
//           <Typography sx={{ color:'#374151', mb:1.5 }}>Are you sure you want to delete this item?</Typography>
//           {deleteItem && (
//             <Box sx={{ p:1.5, borderRadius:2, backgroundColor:'#fef2f2', border:'1px solid #fecaca', mb:1.5 }}>
//               <Typography sx={{ fontWeight:700, color:'#991b1b', fontSize:14 }}>{deleteItem.name_of_item}</Typography>
//               <Typography sx={{ fontSize:12, color:'#b91c1c', fontFamily:'monospace' }}>{deleteItem.full_code}</Typography>
//               {deleteItem.fe_name && (
//                 <Typography sx={{ fontSize:11, color:'#6366f1', mt:0.5 }}>Financial Establishment: {deleteItem.fe_name}</Typography>
//               )}
//             </Box>
//           )}
//           <Typography sx={{ fontSize:12, color:'#ef4444' }}>⚠ This will also delete the QR sticker and all photos from S3.</Typography>
//         </DialogContent>
//         <DialogActions sx={{ px:3, py:2, gap:1 }}>
//           <Button onClick={() => setDeleteDialogOpen(false)} sx={{ color:'#64748b', textTransform:'none', fontWeight:600 }}>Cancel</Button>
//           <Button onClick={handleDelete} variant="contained" color="error" sx={{ textTransform:'none', fontWeight:700, borderRadius:2 }}>
//             Delete Permanently
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={() => setSnackbarOpen(false)} />
//     </Box>
//   );
// };


import React, { useEffect, useState, useCallback } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions, DialogContent,
  TextField, IconButton, MenuItem, Select, InputLabel, FormControl,
  FormHelperText, Chip, Tooltip, Divider, Stack, Autocomplete,
  CircularProgress,
} from '@mui/material';
import {
  Delete, Edit, QrCode2, Add, FilterList, Inventory2, Close,
  CloudUpload, Image as ImageIcon, Person, Download as DownloadIcon,
  Business,
} from '@mui/icons-material';
import axios from 'axios';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import api from '../../api/axiosInterceptor';
import { API_BASE_URL } from '../../config';
import * as XLSX from 'xlsx';

// ─── Constants ────────────────────────────────────────────────────────────────
const CATEGORY_CODES = [
  { value: 'AC',  label: 'Air Conditioners' },
  { value: 'PCP', label: 'Computers & Peripherals' },
  { value: 'EEG', label: 'Electrical & Electronic Goods' },
  { value: 'FF',  label: 'Furniture & Fixtures' },
  { value: 'MTP', label: 'Machinery, Tools & Plant' },
  { value: 'TXT', label: 'Textiles' },
  { value: 'VEH', label: 'Vehicles' },
  { value: 'ANC', label: 'Art Objects & Handicrafts' },
];

const RATINGS    = ['EXCLUSIVE', 'HIGH', 'AVERAGE', 'LOW'];
const CONDITIONS = ['NEW','UNUSED','WORKING','DAMAGED','OBSOLETE','SCRAP','APPRECIATING','DEPRECIATING'];

const CATEGORY_COLORS = {
  AC:'#0ea5e9', PCP:'#8b5cf6', EEG:'#f59e0b', FF:'#10b981',
  MTP:'#ef4444', TXT:'#ec4899', VEH:'#f97316', ANC:'#6366f1',
};

const CONDITION_COLORS = {
  NEW:'#10b981', UNUSED:'#06b6d4', WORKING:'#3b82f6', DAMAGED:'#f59e0b',
  OBSOLETE:'#6b7280', SCRAP:'#ef4444', APPRECIATING:'#8b5cf6', DEPRECIATING:'#f97316',
};

const EMPTY_FORM = {
  category_code:'', sub_code:'', object_code:'', detail_code:'', serial_no_of_group:'',
  name_of_item:'', serial_no_of_item:'', description:'', make_brand:'', rating:'',
  condition:'', condition_details:'', fe: null,
};

// ─── Hook: fetch FE list ──────────────────────────────────────────────────────
const useFetchFeBaseList = () => {
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/fe-mgmt/fe-base/`)
      .then(res => setList(res.data || []))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, []);
  return { list, loading };
};

// ─── Sub-components ───────────────────────────────────────────────────────────
const CategoryBadge = ({ code }) => (
  <Box sx={{
    display:'inline-flex', alignItems:'center', gap:0.5, px:1.2, py:0.3,
    borderRadius:1.5, backgroundColor:`${CATEGORY_COLORS[code]||'#6b7280'}18`,
    border:`1px solid ${CATEGORY_COLORS[code]||'#6b7280'}40`,
  }}>
    <Box sx={{ width:6, height:6, borderRadius:'50%', backgroundColor:CATEGORY_COLORS[code]||'#6b7280' }} />
    <Typography sx={{ fontSize:12, fontWeight:700, color:CATEGORY_COLORS[code]||'#6b7280' }}>{code}</Typography>
  </Box>
);

const ConditionBadge = ({ condition }) => (
  <Chip label={condition||'—'} size="small" sx={{
    fontSize:11, fontWeight:600, height:22,
    backgroundColor:`${CONDITION_COLORS[condition]||'#6b7280'}18`,
    color:CONDITION_COLORS[condition]||'#6b7280',
    border:`1px solid ${CONDITION_COLORS[condition]||'#6b7280'}40`,
  }} />
);

const FeBadge = ({ feObj, feId, feName }) => {
  const name = feObj?.name_of_fe || feName || feId || '—';
  return name !== '—' ? (
    <Box sx={{
      display:'inline-flex', alignItems:'center', gap:0.5, px:1.2, py:0.3,
      borderRadius:1.5, backgroundColor:'rgba(99,102,241,0.1)',
      border:'1px solid rgba(99,102,241,0.3)',
    }}>
      <Person sx={{ fontSize:12, color:'#6366f1' }} />
      <Typography sx={{ fontSize:12, fontWeight:600, color:'#6366f1' }}>
        {typeof name === 'object' ? name.name_of_fe || name : name}
      </Typography>
    </Box>
  ) : (
    <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>
  );
};

const UploadBox = ({ file, onChange, existingUrl, label }) => (
  <Box>
    <Typography sx={{ fontSize:11, color:'#64748b', mb:0.5, fontWeight:600 }}>{label}</Typography>
    <Box component="label" sx={{
      border:`2px dashed ${file ? '#0ea5e9' : '#cbd5e1'}`, borderRadius:2, p:2,
      textAlign:'center', cursor:'pointer',
      backgroundColor: file ? 'rgba(14,165,233,0.04)' : '#f8fafc',
      display:'block', transition:'all 0.2s',
      '&:hover':{ borderColor:'#0ea5e9', backgroundColor:'rgba(14,165,233,0.04)' },
    }}>
      <input type="file" accept="image/*" hidden onChange={e => onChange(e.target.files[0])} />
      <CloudUpload sx={{ fontSize:26, color:file?'#0ea5e9':'#cbd5e1', mb:0.5 }} />
      <Typography sx={{ fontSize:12, color:file?'#0ea5e9':'#94a3b8', fontWeight:600, wordBreak:'break-all' }}>
        {file ? file.name : 'Click to upload'}
      </Typography>
    </Box>
    {!file && existingUrl && (
      <Typography sx={{ fontSize:11, color:'#10b981', mt:0.5 }}>
        ✓ <a href={existingUrl} target="_blank" rel="noreferrer" style={{ color:'#10b981' }}>Current photo</a>
      </Typography>
    )}
  </Box>
);

const SectionLabel = ({ children }) => (
  <Typography sx={{
    fontSize:11, fontWeight:700, letterSpacing:1.2, color:'#94a3b8',
    textTransform:'uppercase', mb:1.5,
  }}>
    {children}
  </Typography>
);

// ─── Main Component ───────────────────────────────────────────────────────────
export const MovableItemsComponent = () => {
  const { list: feList, loading: feLoading } = useFetchFeBaseList();

  const [rows, setRows]                         = useState([]);
  const [loading, setLoading]                   = useState(false);
  const [submitLoading, setSubmitLoading]       = useState(false);

  // ── Filters ───────────────────────────────────────────────────────────────
  // FIX 1: activeFeFilter is now the full FE object (for name resolution)
  const [activeFeFilter, setActiveFeFilter]             = useState(null);   // full FE object
  const [activeCategoryFilter, setActiveCategoryFilter] = useState('ALL');

  const [snackbarOpen, setSnackbarOpen]         = useState(false);
  const [snackbarMessage, setSnackbarMessage]   = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [openFormDialog, setOpenFormDialog]     = useState(false);
  const [isEditMode, setIsEditMode]             = useState(false);
  const [selectedItem, setSelectedItem]         = useState(null);
  const [formData, setFormData]                 = useState(EMPTY_FORM);
  const [formErrors, setFormErrors]             = useState({});
  const [groupPhoto, setGroupPhoto]             = useState(null);
  const [samplePhoto, setSamplePhoto]           = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteItem, setDeleteItem]             = useState(null);
  const [selectedFe, setSelectedFe]             = useState(null);

  // ── Fetch: only runs when FE is selected ─────────────────────────────────
  const fetchItems = useCallback((feId, categoryCode = 'ALL') => {
    if (!feId) return;
    setLoading(true);
    const params = new URLSearchParams();
    params.append('fe', feId);
    if (categoryCode && categoryCode !== 'ALL') params.append('category_code', categoryCode);
    api.get(`/evalueM/movable-items/?${params.toString()}`)
      .then(res => {
        // FIX 2: strict client-side filter — only show rows that truly belong to this FE
        const allItems = res.data || [];
        const filtered = allItems.filter(item => {
          const itemFeId = item.fe?.id ?? item.fe;           // handle nested obj or raw id
          return String(itemFeId) === String(feId);
        });
        // Also apply category filter client-side if needed
        const finalRows = (categoryCode && categoryCode !== 'ALL')
          ? filtered.filter(item => item.category_code === categoryCode)
          : filtered;
        setRows(finalRows.map((item, i) => ({ ...item, slNo: i + 1 })));
      })
      .catch(() => showSnackbar('Failed to load movable items.', 'error'))
      .finally(() => setLoading(false));
  }, []);

  const showSnackbar = (msg, sev = 'info') => {
    setSnackbarMessage(msg); setSnackbarSeverity(sev); setSnackbarOpen(true);
  };

  // FE dropdown changed
  const handleFeFilter = (fe) => {
    setActiveFeFilter(fe);
    setActiveCategoryFilter('ALL');
    setRows([]);
    if (fe) fetchItems(fe.id, 'ALL');
  };

  // Category chip clicked (only if FE already chosen)
  const handleCategoryFilter = (code) => {
    if (!activeFeFilter) return;
    setActiveCategoryFilter(code);
    fetchItems(activeFeFilter.id, code);
  };

  // ── Excel Export ──────────────────────────────────────────────────────────
  const exportToExcel = useCallback(() => {
    // FIX 3: resolve FE name from activeFeFilter (already the full object)
    const activeFeName = activeFeFilter?.name_of_fe || '';

    const headers = [
      'Sl No.', 'Category', 'Full Code', 'Item Name', 'Serial No.',
      'Make/Brand', 'Financial Establishment', 'Condition', 'Rating',
      'QR Sticker Link', 'Group Photo Link', 'Sample Photo Link',
    ];

    const excelData = rows.map((row) => {
      // Resolve FE name: prefer row-level, fall back to active filter name
      const feName =
        row.fe_name ||
        row.fe?.name_of_fe ||
        activeFeName ||
        '';

      return {
        'Sl No.':                  row.slNo,
        'Category':                row.category_code || '',
        'Full Code':               row.full_code || '',
        'Item Name':               row.name_of_item || '',
        'Serial No.':              row.serial_no_of_item || '',
        'Make/Brand':              row.make_brand || '',
        'Financial Establishment': feName,
        'Condition':               row.condition || '',
        'Rating':                  row.rating || '',
        'QR Sticker Link':         row.qr_sticker_url || '',
        'Group Photo Link':        row.group_photo_url || '',
        'Sample Photo Link':       row.sample_photo_url || '',
      };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(excelData, { header: headers });

    ws['!cols'] = [
      { wch: 8 }, { wch: 12 }, { wch: 22 }, { wch: 25 }, { wch: 15 },
      { wch: 18 }, { wch: 32 }, { wch: 14 }, { wch: 12 },
      { wch: 55 }, { wch: 55 }, { wch: 55 },
    ];

    // Clickable hyperlinks for QR, Group Photo, Sample Photo
    [
      { colIndex: 9,  field: 'qr_sticker_url' },
      { colIndex: 10, field: 'group_photo_url' },
      { colIndex: 11, field: 'sample_photo_url' },
    ].forEach(({ colIndex, field }) => {
      rows.forEach((row, rowIndex) => {
        const url = row[field];
        if (url) {
          const cellRef = XLSX.utils.encode_cell({ r: rowIndex + 1, c: colIndex });
          if (ws[cellRef]) {
            ws[cellRef].l = { Target: url, Tooltip: url };
            ws[cellRef].s = { font: { color: { rgb: '0563C1' }, underline: true } };
          }
        }
      });
    });

    XLSX.utils.book_append_sheet(wb, ws, 'Movable Items');
    XLSX.writeFile(wb, `Movable_Items_${activeFeFilter?.name_of_fe || 'All'}_${new Date().toISOString().slice(0, 10)}.xlsx`);
    showSnackbar('Excel downloaded successfully!', 'success');
  }, [rows, activeFeFilter]);

  // ── Columns ───────────────────────────────────────────────────────────────
  const columns = [
    { id:'slNo', field:'slNo', headerName:'Sl No.', width:70 },
    {
      id:'category_code', field:'category_code', headerName:'Category', width:110,
      renderCell:(p) => <CategoryBadge code={p.value} />,
    },
    {
      id:'full_code', field:'full_code', headerName:'Full Code', width:170,
      renderCell:(p) => (
        <Typography sx={{ fontFamily:'monospace', fontSize:12, color:'#475569', fontWeight:600 }}>
          {p.value}
        </Typography>
      ),
    },
    { id:'name_of_item', field:'name_of_item', headerName:'Item Name', width:190 },
    { id:'serial_no_of_item', field:'serial_no_of_item', headerName:'Serial No.', width:120 },
    { id:'make_brand', field:'make_brand', headerName:'Make/Brand', width:130 },
    {
      id:'fe_name', field:'fe_name', headerName:'Financial Establishment', width:220,
      renderCell:(p) => {
        const row = p.row;
        // FIX: prefer row data, fall back to active filter name
        const feName = row.fe_name || row.fe?.name_of_fe || activeFeFilter?.name_of_fe;
        return <FeBadge feObj={row.fe} feId={row.fe} feName={feName} />;
      },
    },
    {
      id:'condition', field:'condition', headerName:'Condition', width:130,
      renderCell:(p) => <ConditionBadge condition={p.value} />,
    },
    {
      id:'rating', field:'rating', headerName:'Rating', width:95,
      renderCell:(p) => (
        <Typography sx={{ fontSize:12, fontWeight:600, color:'#64748b' }}>{p.value||'—'}</Typography>
      ),
    },
    {
      id:'qr_sticker_url', field:'qr_sticker_url', headerName:'QR', width:65,
      renderCell:(p) => p.value ? (
        <Tooltip title="View QR Sticker" arrow>
          <IconButton size="small" onClick={() => window.open(p.value,'_blank')}
            sx={{ color:'#0ea5e9','&:hover':{ backgroundColor:'rgba(14,165,233,0.1)' } }}>
            <QrCode2 fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>,
    },
    {
      id:'photos', field:'photos', headerName:'Photos', width:75,
      renderCell:(p) => {
        const row = p.row;
        if (!row.group_photo_url && !row.sample_photo_url)
          return <Typography sx={{ fontSize:12, color:'#cbd5e1' }}>—</Typography>;
        return (
          <Box sx={{ display:'flex', gap:0.25, flexDirection:'column' }}>
            {row.group_photo_url && (
              <Tooltip title="Group Photo" arrow>
                <IconButton size="small" onClick={() => window.open(row.group_photo_url,'_blank')}
                  sx={{ color:'#10b981','&:hover':{ backgroundColor:'rgba(16,185,129,0.1)' }, p:0.25 }}>
                  <ImageIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {row.sample_photo_url && (
              <Tooltip title="Sample Photo" arrow>
                <IconButton size="small" onClick={() => window.open(row.sample_photo_url,'_blank')}
                  sx={{ color:'#3b82f6','&:hover':{ backgroundColor:'rgba(59,130,246,0.1)' }, p:0.25 }}>
                  <ImageIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
    {
      id:'actions', field:'actions', headerName:'Actions', width:100,
      renderCell:(p) => (
        <Box sx={{ display:'flex', gap:0.5 }}>
          <Tooltip title="Edit" arrow>
            <IconButton size="small" onClick={() => handleEdit(p.row)}
              sx={{ color:'#3b82f6','&:hover':{ backgroundColor:'rgba(59,130,246,0.1)' } }}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <IconButton size="small" onClick={() => handleDeleteConfirmation(p.row)}
              sx={{ color:'#ef4444','&:hover':{ backgroundColor:'rgba(239,68,68,0.1)' } }}>
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  // ── CRUD ──────────────────────────────────────────────────────────────────
  const handleAdd = () => {
    setIsEditMode(false); setFormData(EMPTY_FORM); setSelectedFe(null);
    setGroupPhoto(null); setSamplePhoto(null); setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (item) => {
    setIsEditMode(true); setSelectedItem(item);
    setFormData({
      category_code: item.category_code||'', sub_code: item.sub_code||'',
      object_code: item.object_code||'', detail_code: item.detail_code||'',
      serial_no_of_group: item.serial_no_of_group||'', name_of_item: item.name_of_item||'',
      serial_no_of_item: item.serial_no_of_item||'', description: item.description||'',
      make_brand: item.make_brand||'', rating: item.rating||'',
      condition: item.condition||'', condition_details: item.condition_details||'',
      fe: item.fe?.id ?? item.fe ?? null,
    });
    const itemFeId = item.fe?.id ?? item.fe;
    const matchedFe = feList.find(f => String(f.id) === String(itemFeId)) || null;
    setSelectedFe(matchedFe || (item.fe_name ? { id: itemFeId, name_of_fe: item.fe_name } : null));
    setGroupPhoto(null); setSamplePhoto(null); setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (item) => { setDeleteItem(item); setDeleteDialogOpen(true); };

  const handleDelete = () => {
    api.delete(`/evalueM/movable-items/${deleteItem.id}/`)
      .then(() => {
        showSnackbar('Item deleted successfully.', 'success');
        fetchItems(activeFeFilter?.id, activeCategoryFilter);
      })
      .catch(() => showSnackbar('Failed to delete item.', 'error'))
      .finally(() => { setDeleteDialogOpen(false); setDeleteItem(null); });
  };

  const validate = () => {
    const e = {};
    if (!formData.category_code)        e.category_code = 'Category is required';
    if (!formData.name_of_item?.trim()) e.name_of_item  = 'Item name is required';
    setFormErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setSubmitLoading(true);
    const form = new FormData();
    Object.entries(formData).forEach(([k, v]) => { if (v !== null && v !== undefined) form.append(k, v); });
    if (groupPhoto)  form.append('group_photo_url', groupPhoto);
    if (samplePhoto) form.append('sample_photo_url', samplePhoto);
    const req = isEditMode
      ? api.patch(`/evalueM/movable-items/${selectedItem.id}/`, form, { headers:{ 'Content-Type':'multipart/form-data' } })
      : api.post(`/evalueM/movable-items/`, form, { headers:{ 'Content-Type':'multipart/form-data' } });
    req
      .then(() => {
        showSnackbar(`Item ${isEditMode ? 'updated' : 'added'} & QR sticker generated!`, 'success');
        fetchItems(activeFeFilter?.id, activeCategoryFilter);
      })
      .catch(() => showSnackbar(`Failed to ${isEditMode ? 'update' : 'add'} item.`, 'error'))
      .finally(() => { setSubmitLoading(false); setOpenFormDialog(false); });
  };

  const f = (key) => ({
    value: formData[key], error: !!formErrors[key], helperText: formErrors[key],
    onChange: (e) => setFormData(p => ({ ...p, [key]: e.target.value })),
  });

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ width:'100%', mt:8, mb:1, borderRadius:3, overflow:'visible', boxShadow:'0 8px 32px rgba(15,23,42,0.12)', backgroundColor:'#fff' }}>

      {/* ── Header ── */}
      <Box sx={{
        background:'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #0284c7 100%)',
        px:3, py:2.5, display:'flex', justifyContent:'space-between', alignItems:'center',
        flexWrap:'wrap', gap:1.5, borderRadius:'12px 12px 0 0',
      }}>
        <Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
          <Box sx={{
            width:48, height:48, borderRadius:2,
            background:'rgba(14,165,233,0.2)', border:'1px solid rgba(14,165,233,0.4)',
            display:'flex', alignItems:'center', justifyContent:'center',
          }}>
            <Inventory2 sx={{ color:'#0ea5e9', fontSize:26 }} />
          </Box>
          <Box>
            <Typography sx={{ color:'#fff', fontWeight:800, fontSize:20, letterSpacing:-0.5 }}>
              Movable Assets
            </Typography>
            <Typography sx={{ color:'rgba(255,255,255,0.45)', fontSize:12 }}>
              eValueM · QR Coding & Valuation Module
            </Typography>
          </Box>
        </Box>
        <Button
          startIcon={<Add />}
          onClick={handleAdd}
          sx={{
            background:'linear-gradient(135deg,#0ea5e9,#2563eb)', color:'#fff', fontWeight:700,
            borderRadius:2, px:2.5, py:1, textTransform:'none', whiteSpace:'nowrap', flexShrink:0,
            boxShadow:'0 4px 14px rgba(14,165,233,0.4)',
            '&:hover':{ background:'linear-gradient(135deg,#0284c7,#1d4ed8)', transform:'translateY(-1px)' },
            transition:'all 0.2s',
          }}
        >
          Add Item
        </Button>
      </Box>

      {/* ── FIX 1: FE Filter — now a styled MUI Select dropdown ── */}
      <Box sx={{ px:3, py:2, borderBottom:'1px solid #f1f5f9', backgroundColor:'#fafaff' }}>
        <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1.5 }}>
          <Business sx={{ fontSize:15, color:'#6366f1' }} />
          <Typography sx={{ fontSize:12, color:'#6366f1', fontWeight:700 }}>
            Financial Establishment
          </Typography>
          {!activeFeFilter && (
            <Typography sx={{ fontSize:11, color:'#f59e0b', fontWeight:600, ml:1 }}>
              ← Select one to load data
            </Typography>
          )}
        </Box>

        <FormControl size="small" sx={{ minWidth: 320 }}>
          <InputLabel>Select Financial Establishment</InputLabel>
          <Select
            label="Select Financial Establishment"
            value={activeFeFilter?.id ?? ''}
            onChange={(e) => {
              const val = e.target.value;
              if (!val) {
                handleFeFilter(null);
              } else {
                const fe = feList.find(f => f.id === val);
                if (fe) handleFeFilter(fe);
              }
            }}
            startAdornment={
              feLoading
                ? <CircularProgress size={16} sx={{ mr:1, color:'#6366f1' }} />
                : <Person sx={{ fontSize:18, color:'#6366f1', mr:0.5 }} />
            }
            renderValue={(val) => {
              if (!val) return <em style={{ color:'#94a3b8' }}>-- Select FE --</em>;
              const fe = feList.find(f => f.id === val);
              return (
                <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                  <Box sx={{
                    width:22, height:22, borderRadius:'50%',
                    background:'linear-gradient(135deg,#6366f1,#8b5cf6)',
                    display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
                  }}>
                    <Typography sx={{ color:'#fff', fontSize:10, fontWeight:700 }}>
                      {(fe?.name_of_fe || '?')[0].toUpperCase()}
                    </Typography>
                  </Box>
                  <Typography sx={{ fontSize:13, fontWeight:600, color:'#1e293b' }}>
                    {fe?.name_of_fe || val}
                  </Typography>
                </Box>
              );
            }}
            sx={{
              borderRadius:2,
              '& .MuiOutlinedInput-notchedOutline':{ borderColor:'#e2e8f0' },
              '&:hover .MuiOutlinedInput-notchedOutline':{ borderColor:'#6366f1' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline':{ borderColor:'#6366f1' },
            }}
          >
            <MenuItem value="">
              <em style={{ color:'#94a3b8' }}>-- None / Clear --</em>
            </MenuItem>
            {feList.map(fe => (
              <MenuItem key={fe.id} value={fe.id}>
                <Box sx={{ display:'flex', alignItems:'center', gap:1.5, py:0.5 }}>
                  <Box sx={{
                    width:28, height:28, borderRadius:'50%',
                    background:'linear-gradient(135deg,#6366f1,#8b5cf6)',
                    display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
                  }}>
                    <Typography sx={{ color:'#fff', fontSize:11, fontWeight:700 }}>
                      {(fe.name_of_fe || '?')[0].toUpperCase()}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize:13, fontWeight:600 }}>{fe.name_of_fe}</Typography>
                    {fe.employee_id && (
                      <Typography sx={{ fontSize:11, color:'#94a3b8' }}>ID: {fe.employee_id}</Typography>
                    )}
                  </Box>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* ── Category Filter Bar (only visible after FE selected) ── */}
      {activeFeFilter && (
        <Box sx={{ px:3, py:1.5, borderBottom:'1px solid #f1f5f9', display:'flex', gap:1, alignItems:'center', flexWrap:'wrap', backgroundColor:'#f8fafc' }}>
          <FilterList sx={{ fontSize:16, color:'#94a3b8' }} />
          <Typography sx={{ fontSize:12, color:'#94a3b8', fontWeight:600, mr:0.5 }}>Category:</Typography>
          {[{ value:'ALL', label:'All' }, ...CATEGORY_CODES].map(cat => (
            <Chip
              key={cat.value}
              label={cat.label || cat.value}
              variant="outlined"
              size="small"
              onClick={() => handleCategoryFilter(cat.value)}
              sx={{
                cursor:'pointer',
                fontWeight: activeCategoryFilter === cat.value ? 700 : 400,
                borderColor: activeCategoryFilter === cat.value ? '#0ea5e9' : '#e2e8f0',
                color: activeCategoryFilter === cat.value ? '#0ea5e9' : '#64748b',
                backgroundColor: activeCategoryFilter === cat.value ? 'rgba(14,165,233,0.08)' : '#fff',
                '&:hover':{ borderColor:'#0ea5e9', color:'#0ea5e9' },
                transition:'all 0.15s',
              }}
            />
          ))}
        </Box>
      )}

      {/* ── Stats + Excel Bar ── */}
      <Box sx={{
        px:3, py:1.5, display:'flex', alignItems:'center',
        justifyContent:'space-between', borderBottom:'1px solid #f1f5f9',
        backgroundColor:'#fff', minHeight:56,
      }}>
        <Box sx={{ display:'flex', gap:4, alignItems:'center', flexWrap:'wrap' }}>
          {[
            { label:'Total Items',     value: rows.length,                                                                   color:'#0ea5e9' },
            { label:'With QR',         value: rows.filter(r => r.qr_sticker_url).length,                                     color:'#10b981' },
            { label:'Assigned to FE',  value: rows.filter(r => r.fe || r.fe_name).length,                                    color:'#6366f1' },
            { label:'Damaged / Scrap', value: rows.filter(r => ['DAMAGED','SCRAP','OBSOLETE'].includes(r.condition)).length,  color:'#ef4444' },
          ].map(s => (
            <Box key={s.label} sx={{ display:'flex', alignItems:'baseline', gap:0.5 }}>
              <Typography sx={{ fontSize:22, fontWeight:800, color:s.color, lineHeight:1 }}>{s.value}</Typography>
              <Typography sx={{ fontSize:12, color:'#94a3b8' }}>{s.label}</Typography>
            </Box>
          ))}
        </Box>

        <Button
          onClick={exportToExcel}
          disabled={rows.length === 0}
          startIcon={<DownloadIcon />}
          variant="contained"
          sx={{
            ml:2, flexShrink:0, whiteSpace:'nowrap', fontWeight:700,
            textTransform:'none', borderRadius:2, px:2.5, py:0.9, fontSize:13,
            background:'linear-gradient(135deg,#10b981,#059669)',
            boxShadow:'0 4px 14px rgba(16,185,129,0.35)',
            '&:hover':{ background:'linear-gradient(135deg,#047857,#065f46)', transform:'translateY(-1px)' },
            '&.Mui-disabled':{ background:'#e2e8f0', color:'#94a3b8', boxShadow:'none' },
            transition:'all 0.2s',
          }}
        >
          Download Excel ({rows.length})
        </Button>
      </Box>

      {/* ── Body ── */}
      {!activeFeFilter ? (
        <Box sx={{ py:10, display:'flex', flexDirection:'column', alignItems:'center', gap:2 }}>
          <Business sx={{ fontSize:64, color:'#e2e8f0' }} />
          <Typography sx={{ fontSize:17, fontWeight:700, color:'#94a3b8' }}>
            Select a Financial Establishment
          </Typography>
          <Typography sx={{ fontSize:13, color:'#cbd5e1' }}>
            Choose an FE from the dropdown above to load its movable assets.
          </Typography>
        </Box>
      ) : loading ? (
        <Box sx={{ py:8, display:'flex', justifyContent:'center' }}>
          <LoadingSpinner size={30} />
        </Box>
      ) : (
        <TableComponent
          columns={columns}
          rows={rows}
          manageColumnStatus
          enableSort="true"
          sx={{
            '& .MuiDataGrid-columnHeaders':{ backgroundColor:'#f8fafc', color:'#374151', fontWeight:700, fontSize:12, borderBottom:'2px solid #e2e8f0' },
            '& .MuiDataGrid-row:hover':{ backgroundColor:'#f0f9ff' },
          }}
        />
      )}

      {/* ── Add / Edit Dialog ── */}
      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}
        PaperProps={{ sx:{ borderRadius:3, minWidth:600, boxShadow:'0 25px 60px rgba(15,23,42,0.25)' } }}>
        <Box sx={{
          background:'linear-gradient(135deg,#0f172a,#1e3a5f)', color:'#fff', py:2, px:3,
          display:'flex', justifyContent:'space-between', alignItems:'center',
        }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
            <QrCode2 sx={{ color:'#0ea5e9', fontSize:22 }} />
            <Typography sx={{ fontWeight:700, fontSize:16 }}>
              {isEditMode ? 'Edit Movable Item' : 'Register Movable Item'}
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setOpenFormDialog(false)} sx={{ color:'rgba(255,255,255,0.6)' }}>
            <Close fontSize="small" />
          </IconButton>
        </Box>

        <DialogContent sx={{ px:3, py:2.5, maxHeight:'72vh', overflowY:'auto' }}>
          <SectionLabel>① Financial Establishment</SectionLabel>
          <Autocomplete
            size="small" options={feList} loading={feLoading} value={selectedFe}
            getOptionLabel={(opt) => opt?.name_of_fe || ''}
            isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
            onChange={(_, newVal) => {
              setSelectedFe(newVal);
              setFormData(p => ({ ...p, fe: newVal ? newVal.id : null }));
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select Financial Establishment" placeholder="Search by name…"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (<><Person sx={{ fontSize:18, color:'#6366f1', mr:0.5 }} />{params.InputProps.startAdornment}</>),
                  endAdornment: (<>{feLoading ? <CircularProgress size={16} /> : null}{params.InputProps.endAdornment}</>),
                }}
              />
            )}
            renderOption={(props, opt) => (
              <Box component="li" {...props} sx={{ display:'flex', alignItems:'center', gap:1.5, py:1 }}>
                <Box sx={{ width:30, height:30, borderRadius:'50%', background:'linear-gradient(135deg,#6366f1,#8b5cf6)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <Typography sx={{ color:'#fff', fontSize:12, fontWeight:700 }}>{(opt.name_of_fe||'?')[0].toUpperCase()}</Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize:13, fontWeight:600 }}>{opt.name_of_fe}</Typography>
                  {opt.employee_id && <Typography sx={{ fontSize:11, color:'#94a3b8' }}>ID: {opt.employee_id}</Typography>}
                </Box>
              </Box>
            )}
            sx={{ mb:2 }}
          />
          <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

          <SectionLabel>② Coding Hierarchy</SectionLabel>
          <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:2 }}>
            <FormControl fullWidth size="small" error={!!formErrors.category_code}>
              <InputLabel>Category Code *</InputLabel>
              <Select label="Category Code *" value={formData.category_code}
                onChange={e => setFormData(p => ({ ...p, category_code:e.target.value }))}>
                {CATEGORY_CODES.map(c => (
                  <MenuItem key={c.value} value={c.value}>
                    <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                      <Box sx={{ width:8, height:8, borderRadius:'50%', backgroundColor:CATEGORY_COLORS[c.value] }} />
                      <span style={{ fontWeight:600 }}>{c.value}</span>
                      <span style={{ color:'#94a3b8', fontSize:12 }}>· {c.label}</span>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
              {formErrors.category_code && <FormHelperText>{formErrors.category_code}</FormHelperText>}
            </FormControl>
            <TextField size="small" label="Sub Code" placeholder="-SPL" {...f('sub_code')} />
            <TextField size="small" label="Object Code" placeholder="--LCD" {...f('object_code')} />
            <TextField size="small" label="Detail Code" placeholder="---KB" {...f('detail_code')} />
          </Box>
          {formData.category_code && (
            <Box sx={{ mb:2, px:2, py:1, borderRadius:1.5, backgroundColor:'#f8fafc', border:'1px solid #e2e8f0', display:'flex', alignItems:'center', gap:1 }}>
              <Typography sx={{ fontSize:11, color:'#94a3b8', fontWeight:600 }}>FULL CODE PREVIEW:</Typography>
              <Typography sx={{ fontFamily:'monospace', fontSize:13, fontWeight:700, color:'#0f172a' }}>
                {formData.category_code}{formData.sub_code}{formData.object_code}{formData.detail_code}
              </Typography>
            </Box>
          )}
          <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

          <SectionLabel>③ Item Details</SectionLabel>
          <Stack spacing={1.5} sx={{ mb:2 }}>
            <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5 }}>
              <TextField size="small" label="Item Name *" {...f('name_of_item')} />
              <TextField size="small" label="Make / Brand" {...f('make_brand')} />
              <TextField size="small" label="Serial No. of Item" {...f('serial_no_of_item')} />
              <TextField size="small" label="Serial No. of Group" {...f('serial_no_of_group')} />
            </Box>
            <TextField size="small" label="Description (material, colour, order)" multiline rows={2} {...f('description')} />
          </Stack>
          <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

          <SectionLabel>④ Valuation & Condition</SectionLabel>
          <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:1.5 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Rating</InputLabel>
              <Select label="Rating" value={formData.rating} onChange={e => setFormData(p => ({ ...p, rating:e.target.value }))}>
                <MenuItem value=""><em>None</em></MenuItem>
                {RATINGS.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl fullWidth size="small">
              <InputLabel>Condition</InputLabel>
              <Select label="Condition" value={formData.condition} onChange={e => setFormData(p => ({ ...p, condition:e.target.value }))}>
                <MenuItem value=""><em>None</em></MenuItem>
                {CONDITIONS.map(c => (
                  <MenuItem key={c} value={c}>
                    <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
                      <Box sx={{ width:8, height:8, borderRadius:'50%', backgroundColor:CONDITION_COLORS[c] }} />
                      {c}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {['DAMAGED','OBSOLETE'].includes(formData.condition) && (
            <TextField size="small" fullWidth label="Condition Details" multiline rows={2} sx={{ mb:1.5 }} {...f('condition_details')} />
          )}
          <Divider sx={{ my:2, borderColor:'#f1f5f9' }} />

          <SectionLabel>⑤ Photos</SectionLabel>
          <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1.5, mb:2 }}>
            <UploadBox file={groupPhoto} onChange={setGroupPhoto} label="Group Photo" existingUrl={isEditMode ? selectedItem?.group_photo_url : null} />
            <UploadBox file={samplePhoto} onChange={setSamplePhoto} label="Sample Photo" existingUrl={isEditMode ? selectedItem?.sample_photo_url : null} />
          </Box>
          <Box sx={{
            p:1.5, borderRadius:2,
            background:'linear-gradient(135deg,rgba(14,165,233,0.08),rgba(99,102,241,0.08))',
            border:'1px solid rgba(14,165,233,0.2)', display:'flex', alignItems:'center', gap:1.5,
          }}>
            <QrCode2 sx={{ color:'#0ea5e9', fontSize:28, flexShrink:0 }} />
            <Typography sx={{ fontSize:12, color:'#475569', lineHeight:1.5 }}>
              <strong style={{ color:'#0ea5e9' }}>QR Sticker auto-generated</strong> on save — contains Category Code, Item Name, Serial No. & Condition. Uploaded to S3 automatically.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px:3, py:2, borderTop:'1px solid #f1f5f9', gap:1 }}>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}
            sx={{ color:'#64748b', textTransform:'none', fontWeight:600 }}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={submitLoading} sx={{
            background:'linear-gradient(135deg,#0ea5e9,#2563eb)', color:'#fff', fontWeight:700,
            textTransform:'none', px:3, borderRadius:2,
            '&:hover':{ background:'linear-gradient(135deg,#0284c7,#1d4ed8)' },
          }}>
            {submitLoading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update & Regenerate QR' : 'Save & Generate QR'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete Confirmation ── */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}
        PaperProps={{ sx:{ borderRadius:3, minWidth:400, boxShadow:'0 25px 60px rgba(15,23,42,0.25)' } }}>
        <Box sx={{
          background:'linear-gradient(135deg,#7f1d1d,#991b1b)', color:'#fff', py:2, px:3,
          display:'flex', justifyContent:'space-between', alignItems:'center',
        }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
            <Delete sx={{ color:'#fca5a5', fontSize:20 }} />
            <Typography sx={{ fontWeight:700 }}>Confirm Delete</Typography>
          </Box>
          <IconButton size="small" onClick={() => setDeleteDialogOpen(false)} sx={{ color:'rgba(255,255,255,0.6)' }}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
        <DialogContent sx={{ py:3, px:3 }}>
          <Typography sx={{ color:'#374151', mb:1.5 }}>Are you sure you want to delete this item?</Typography>
          {deleteItem && (
            <Box sx={{ p:1.5, borderRadius:2, backgroundColor:'#fef2f2', border:'1px solid #fecaca', mb:1.5 }}>
              <Typography sx={{ fontWeight:700, color:'#991b1b', fontSize:14 }}>{deleteItem.name_of_item}</Typography>
              <Typography sx={{ fontSize:12, color:'#b91c1c', fontFamily:'monospace' }}>{deleteItem.full_code}</Typography>
              {deleteItem.fe_name && (
                <Typography sx={{ fontSize:11, color:'#6366f1', mt:0.5 }}>Financial Establishment: {deleteItem.fe_name}</Typography>
              )}
            </Box>
          )}
          <Typography sx={{ fontSize:12, color:'#ef4444' }}>⚠ This will also delete the QR sticker and all photos from S3.</Typography>
        </DialogContent>
        <DialogActions sx={{ px:3, py:2, gap:1 }}>
          <Button onClick={() => setDeleteDialogOpen(false)} sx={{ color:'#64748b', textTransform:'none', fontWeight:600 }}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error" sx={{ textTransform:'none', fontWeight:700, borderRadius:2 }}>
            Delete Permanently
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={() => setSnackbarOpen(false)} />
    </Box>
  );
};